/** Spanish translations */
import type { TranslationDict } from "./tr";

const es: TranslationDict = {
  common: {
    privacyPre: "Tus datos personales se tratan según nuestro ",
    privacyLink: "aviso de privacidad",
    termsLink: "Condiciones de uso",
    privacyPost: ".",
    all: "Todos",
    save: "Guardar",
    saving: "Guardando...",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Agregar",
    adding: "Agregando...",
    create: "Crear",
    creating: "Creando...",
    close: "Cerrar",
    /** Belge yazımı reddedildi (409 stale_write): veri tazelendi. */
    staleWrite: "Este registro cambió en otro lugar mientras lo editabas. Se cargó la versión más reciente: revisa tu cambio y vuelve a guardar.",
    back: "Volver",
    loading: "Cargando...",
    loadMore: "Cargar más",
    perPage: "por página",
    logout: "Cerrar sesión",
    switchToLight: "Cambiar a modo claro",
    switchToDark: "Cambiar a modo oscuro",
    error: "Error",
    unknownError: "Error desconocido",
    errorOccurred: "Ocurrió un error",
    confirm: "Confirmar",
    phone: "Teléfono",
    email: "Correo electrónico",
    name: "Nombre",
    date: "Fecha",
    actions: "Acciones",
    yes: "Sí",
    no: "No",
    none: "Ninguno",
    other: "Otro",
    total: "Total",
    language: "Idioma",
    uploading: "Subiendo...",
    upload: "Subir",
    skip: "Omitir",
    chooseFile: "Elegir archivo",
    remove: "Eliminar",
    help: "Ayuda",
    left: "restante",
    more: "Más",
    otherPages: "Otras páginas",
    optional: "opcional",
  },
  nav: {
    dashboard: "Panel",
    guests: "Invitados",
    sms: "SMS",
    moderation: "Moderación",
    organizers: "Organizadores",
    users: "Usuarios",
    weddings: "Bodas",
    myWeddings: "Mis Bodas",
    profile: "Mi Perfil",
    home: "Inicio",
    rsvp: "RSVP",
    upload: "Subir",
    gallery: "Galería",
    slideshow: "Escenario",
    reji: "Reji",
    analytics: "Analítica QR",
    allWeddings: "Todas las Bodas",
    backToWeddings: "Volver a las Bodas",
    organizer: "Organizador",
    maintenance: "Seguimiento de errores",
    controlCenter: "Centro de control",
    smsCenter: "Centro SMS",
    site: "Ventas y Sitio",
    privacy: "Solicitudes KVKK",
    print: "Impresión",
    themes: "Temas",
    settings: "Ajustes",
    packages: "Mis paquetes",
  },
  auth: {
    welcomeTitle: "Bienvenido a Nuestra Boda",
    loginTitle: "Iniciar sesión",
    loginDesc: "Te enviaremos un código de verificación por SMS",
    phoneLabel: "Teléfono",
    login: "Iniciar sesión",
    verifyTitle: "Código de Verificación",
    verifyDesc: "Ingresa el código de 6 dígitos enviado a tu teléfono",
    codeLabel: "Código",
    verify: "Verificar",
    phonePlaceholder: "+34 XXX XXX XXX",
    loggingIn: "Iniciando sesión...",
    enterCode: "Ingresa el código de 6 dígitos enviado a tu teléfono",
    verifying: "Verificando...",
    wrongNumber: "Cambiar número",
    changeNumber: "Cambiar número",
    turnstileRequired: "Por favor completa la verificación",
    codeFailed: "La verificación del código falló",
    logoutLabel: "Cerrar sesión",
    codePlaceholder: "123456",
    otpUnavailable: "La verificación SMS no está disponible en este momento. Por favor, contacta al organizador.",
    invalidPhone: "Ingresa un número de teléfono válido — puedes incluir el 0 inicial.",
    countrySelectLabel: "Código de país",
    countrySearchPlaceholder: "Buscar país…",
    noCountryResults: "No se encontraron países",
    phoneHint: "Puedes escribirlo con o sin el 0 inicial — lo corregimos",
    banned: "Tu acceso a esta boda ha sido suspendido. Por favor, contacta al organizador.",
    celebrationPrefix: "Una celebración del amor:",
    tabLogin: "Iniciar sesión",
    tabRegister: "Registrarse",
    registerTitle: "Registrarse",
    registerDesc: "Introduce tu nombre y número de teléfono para unirte a la boda.",
    alreadyRegisteredTitle: "Ya estás registrado",
    alreadyRegisteredDesc: "Este número ya está registrado — inicia sesión para continuar.",
    alreadyRegisteredSwitch: "Iniciar sesión",
  },
  organizerAuth: {
    signupClosed: "No hay una cuenta de organizador con este correo. Las cuentas nuevas se abren tras un presupuesto — solicítalo en el formulario de wedding.mertbal.com.",
    title: "Inicio de Sesión del Organizador",
    emailPrompt: "Ingresa tu dirección de correo electrónico",
    codePrompt: "Ingresa el código enviado a tu correo",
    emailLabel: "Correo electrónico",
    sendCode: "Enviar Código",
    verifyCode: "Código de Verificación",
    login: "Iniciar Sesión",
    changeEmail: "Usar otro correo",
    emailPlaceholder: "organizador@ejemplo.com",
    panelTitle: "Panel del Organizador",
    tagline: "Gestiona tus bodas",
    welcomeBack: "Bienvenido",
    verifyTitle: "Verifique su identidad",
    verifyHint: "Si existe una cuenta para {{email}}, enviamos un código de 6 dígitos. Si no, esa dirección recibe un correo informativo.",
    signupVerifyHint: "Enviamos el código a {{email}}: introdúcelo para abrir tu cuenta.",
    noAccount: "¿Aún no tienes cuenta?",
    signupCta: "Crear una cuenta",
    quoteCta: "Pedir presupuesto",
    haveAccount: "¿Ya tienes cuenta?",
    loginCta: "Iniciar sesión",
    signupTitle: "Crear una cuenta",
    signupPrompt: "Escribe tu nombre y tu correo; tu cuenta se abre con el código que te enviamos.",
    nameLabel: "Nombre completo",
    namePlaceholder: "Ana García",
    acceptTerms: "las condiciones de uso",
    acceptAnd: " y ",
    acceptKvkk: "el aviso de privacidad",
    acceptPost: ": las he leído y las acepto.",
    createAccount: "Crear cuenta",
    signupMissing: "Escribe tu nombre y acepta las condiciones.",
    signupClosedTitle: "Las cuentas nuevas se abren con presupuesto",
    signupClosedBody: "Rellena el formulario de nuestra web para precios; nosotros abrimos tu cuenta.",
    disposableEmail: "Esta dirección de correo no se acepta. Usa una dirección permanente.",
    emailAliasExists: "Ya existe una cuenta para este buzón (la misma dirección con puntos o una +etiqueta). Inicia sesión con tu dirección existente.",
    tooManySignups: "Demasiados registros desde esta red hoy. Inténtalo más tarde.",
    accountNotFound: "No hay ninguna cuenta vinculada a este correo o el registro caducó. Inténtalo de nuevo.",
    secureGateway: "Acceso Seguro",
  },
  dashboard: {
    title: "Panel",
    totalGuests: "Total de Invitados",
    attending: "Asistirán",
    people: "personas",
    maybe: "Tal vez",
    notAttending: "No Asistirán",
    pendingMedia: "Medios Pendientes",
    approvedMedia: "Medios Aprobados",
    welcomeBack: "Bienvenido,",
    activityFeed: "Actividad reciente",
    quickActions: "Acciones rápidas",
    daysLeft: "días restantes",
    weddingPast: "¡Qué día tan especial!",
    inviteLink: "Enlace de invitación",
    inviteLinkHint: "Comparte este enlace con tus invitados para unirse a tu boda.",
    copied: "¡Copiado!",
    eventStatus: "Estado del evento",
    statusOn: "Activo",
    statusOff: "Inactivo",
    statusScheduled: "Programado",
    recentMedia: "Fotos recientes",
    noMediaYet: "Aún no hay fotos aprobadas",
    capacityUsed: "Capacidad utilizada",
    pendingAlert: "fotos pendientes de revisión",
    pendingAlertSub: "Abrir cola de moderación",
    quickGuestsSub: "Gestionar lista de invitados",
    quickModerationSub: "Revisar subidas pendientes",
    quickGallerySub: "Explorar medios aprobados",
    quickSettingsSub: "Configuración de la boda",
    noActivity: "Sin actividad reciente",
    qrFunnelTitle: "Embudo QR",
    qrScans: "Escaneos",
    qrRegistrations: "Registros",
    qrConversion: "Conversión",
    qrFunnelEmpty: "Aún no hay escaneos — comparte tu código QR",
    qrFunnelDetail: "Detalles",
  },
  analytics: {
    title: "Analítica QR",
    summary: "Resumen",
    scans: "Escaneos",
    unique: "Únicos",
    registrations: "Registros",
    conversion: "Conversión",
    byDay: "Tiempo",
    byDevice: "Dispositivo",
    byLocation: "Ubicación",
    funnel: "Embudo",
    unknown: "Desconocido",
    exportCsv: "Descargar CSV",
    empty: "Aún no hay escaneos — comparte tu código QR",
    csvOk: "CSV descargado",
    csvErr: "Error al descargar",
    peak: "Pico",
    share: "parte",
    deviceMobile: "Móvil",
    deviceTablet: "Tableta",
    deviceDesktop: "Escritorio",
    refresh: "Actualizar",
    exportPdf: "Descargar informe",
    reportTitle: "Informe de analítica QR",
    peakDay: "Día pico",
    generatedAt: "Generado",
    pdfOk: "Informe descargado",
    pdfErr: "No se pudo generar el informe",
  },
  guests: {
    title: "Invitados",
    titleCount: "Invitados ({{count}})",
    phoneRequired: "Teléfono *",
    namePlaceholder: "Juan Pérez",
    importBtn: "Importar",
    exportBtn: "Exportar",
    jsonFormat: "Formato JSON:",
    columnPhone: "Teléfono",
    columnName: "Nombre",
    columnRsvp: "RSVP",
    columnHeadcount: "Cantidad",
    columnDiet: "Dieta",
    columnNotes: "Notas",
    columnEditedBy: "Editado por",
    columnDate: "Fecha",
    dietNone: "Ninguna",
    dietVegan: "Vegano",
    dietVegetarian: "Vegetariano",
    dietGlutenFree: "Sin gluten",
    dietOther: "Otro",
    deleteConfirm: '¿Está seguro de que desea eliminar a "{{name}}"?',
    importSuccess: "{{imported}} invitados agregados, {{skipped}} omitidos (total: {{total}})",
    importJsonError: "El archivo JSON debe ser un arreglo o formato { guests: [...] }",
    added: "Invitado añadido",
    deleted: "Invitado eliminado",
    deleteNoMedia: "El invitado se quitará de la lista. No tiene subidas.",
    deleteMediaKept: "El invitado se quitará de la lista. Sus {{count}} archivo(s) SIGUEN en la galería — marca la casilla para borrarlos también.",
    deleteMediaToo: "Borrar también sus {{count}} archivo(s)",
    deleteMediaTooHint: "Los medios borrados se pueden restaurar en Moderación → Eliminados durante {{days}} días; después se eliminan definitivamente.",
    saved: "Cambios guardados",
    exported: "{{count}} invitados exportados",
    phoneHint: "Incluir código de país — ej. +34612345678",
    phoneInvalid: "Número inválido — incluir código de país (ej. +34...)",
    nameRequired: "El nombre es obligatorio",
    banGuest: "Banear invitado",
    smsConsentOn: "Consentimiento SMS activo — clic para quitar",
    smsConsentOff: "Sin consentimiento SMS — clic para añadir",
    smsOptedOut: "El invitado rechazó los SMS",
    smsConsentSet: "Consentimiento SMS añadido",
    smsConsentUnset: "Consentimiento SMS eliminado",
    banDuration1d: "1 Día",
    banDuration7d: "7 Días",
    banDuration30d: "30 Días",
    banReasonPlaceholder: "Motivo (opcional)",
    banPermanent: "Permanente",
    banUntil: "Baneado — hasta {{date}}",
    banPermanentLabel: "Baneado permanentemente",
    unban: "Quitar ban",
    banned: "Baneado",
    guestBanned: "Invitado baneado",
    guestUnbanned: "Ban eliminado",
    addGuest: "Añadir invitado",
    editTitle: "Editar invitado",
    filterAll: "Todos",
    filterNone: "Sin RSVP",
    rsvpYes: "Confirmado",
    rsvpNo: "Declinado",
    rsvpMaybe: "Quizás",
    rsvpYesCount: "{{count}} asistirán",
    rsvpNoCount: "{{count}} declinan",
    rsvpMaybeCount: "{{count}} quizás",
    noGuests: "Aún no hay invitados",
    noGuestsSearch: "Ningún invitado coincide con tu búsqueda",
    noName: "Sin nombre",
    searchPlaceholder: "Buscar por nombre o teléfono…",
    columnDetails: "Detalles",
    headcountLabel: "{{count}} personas",
    headcountMax: "Máx. {{max}}",
    headcountPerson: "personas",
    timeMinutes: "{{count}}min",
    timeHours: "{{count}}h",
    timeDays: "{{count}}d",
    diet_vegan: "Vegano",
    diet_vegetarian: "Vegetariano",
    diet_gluten_free: "Sin gluten",
    diet_other: "Especial",
  },
  moderation: {
    title: "Moderación de Medios",
    titleCount: "Moderación de Medios ({{count}} pendientes)",
    noItems: "No hay medios pendientes",
    approve: "Aprobar",
    reject: "Rechazar",
    reviewedBy: "Revisado por: {{email}}",
    history: "Historial",
    pending: "Pendientes",
    returnToPending: "Devolver a revisión",
    autoRefreshOff: "Actualización automática desactivada",
    refreshNow: "Actualizar",
    autoRefreshOn: "Actualización automática activada ({{s}}s)",
    bulkApprove: "Aprobar selección",
    bulkReject: "Rechazar selección",
    bulkApproved: "Elementos seleccionados aprobados",
    bulkRejected: "Elementos seleccionados rechazados",
    rejectDeleteHint: "Rechazado — el archivo se eliminará permanentemente en 7 días",
    bulkRejectedDeleteHint: "Rechazados — los archivos se eliminarán permanentemente en 7 días",
    deletesIn: "Se elimina en {{days}}d",
    deletesInHours: "Se elimina en {{hours}}h",
    deletesImminently: "Eliminación inminente",
    selected: "{{count}} seleccionado(s)",
    selectAll: "Seleccionar todo",
    deselectAll: "Deseleccionar todo",
    tabApproved: "Aprobados",
    tabRejected: "Rechazados",
    tabDeleted: "Eliminados",
    noDeleted: "No hay medios eliminados",
    deletedHint: "Estos elementos se eliminarán definitivamente en {{days}} días. Pulsa Restaurar para recuperarlos.",
    restore: "Restaurar",
    guestRemovedLocked: "Quitado por el invitado",
    guestRemovedLockedHint: "El invitado lo quitó. La decisión es suya: no se puede restaurar ni aprobar y se borra definitivamente al terminar el plazo.",
    restored: "Medio restaurado",
    guestDeleted: "invitado eliminado",
    unknownGuest: "Invitado desconocido",
  },
  wedding: {
    title: "Bodas",
    myWeddings: "Mis Bodas",
    newWedding: "Nueva Boda",
    createTitle: "Crear Nueva Boda",
    slugPlaceholder: "Slug URL (ej: juan-maria)",
    titlePlaceholder: "Título de la boda",
    datePlaceholder: "Fecha y hora",
    locationPlaceholder: "Ubicación",
    created: "Boda creada",
    createFailed: "No se pudo crear la boda",
    deleteConfirm: '¿Está seguro de que desea eliminar "{{slug}}"? Esta acción no se puede deshacer.',
    deleteFailed: "No se pudo eliminar",
    deleteButton: "Eliminar boda",
    archiveConfirm: '¿Está seguro de que desea archivar "{{slug}}"? Se eliminará de su lista pero los datos se conservarán. Sigue contando para su límite de plan.',
    archived: "Boda archivada",
    archiveFailed: "No se pudo archivar",
    archiveButton: "Archivar boda",
    unarchived: "Boda restaurada",
    unarchiveFailed: "No se pudo restaurar",
    unarchiveButton: "Restaurar boda",
    archivedSection: "Bodas archivadas",
    archivedBadge: "Archivada",
    noWeddings: "Aún no tiene bodas.",
    noWeddingsHint: 'Cree su primera boda usando el botón "Nueva Boda" de arriba.',
    notFound: "Boda No Encontrada",
    noWeddingsAdmin: "No se han creado bodas aún",
    owner: "Propietario",
    enterTitle: "Ingrese un título para la boda",
    enterDate: "Ingrese la fecha y hora de la boda",
    enterLocation: "Ingrese la ubicación de la boda",
    descriptionPlaceholder: "Descripción (opcional)",
    infoTab: "Detalles de la Boda",
    registrationTab: "Registro",
    bgTab: "Fondos",
    notificationsTab: "Notificaciones",
    slugReadOnly: "El slug es permanente y no se puede cambiar",
    settingsHint: "Administra los detalles de tu boda y la configuración de registro.",
    updateSuccess: "Detalles de la boda guardados",
    mainEventLabel: "Boda",
    event2: {
      sectionTitle: "Segundo evento",
      sectionHint: "Añade un evento adicional como la noche de henna, la ceremonia civil o la after-party.",
      addButton: "Añadir segundo evento",
      removeButton: "Quitar",
      dateTimeLabel: "Fecha y hora",
      locationLabel: "Lugar",
      locationPlaceholder: "Nombre del lugar o dirección",
      labelLabel: "Tipo de evento",
      customLabelPlaceholder: "Escribe el nombre del evento",
      dateRequired: "La fecha y la hora son obligatorias para el segundo evento",
      customLabelRequired: "El nombre del evento es obligatorio si eliges «Otro»",
    },
    program: {
      programTitle: "Programa",
      daysLeft: "FALTAN {{count}} DÍAS",
      today: "HOY",
      past: "FINALIZADO",
      tomorrow: "MAÑANA",
      mainEventTypeLabel: "Tipo del evento principal",
    },
    event2Label: {
      kina: "Noche de henna",
      nikah: "Ceremonia civil",
      dugun: "Boda",
      afterParty: "After party",
      other: "Otro",
    },
    updateFailed: "Error al guardar",
    eventDateLocked: "La fecha del evento ya pasó — ya no se puede cambiar (un paquete cubre un solo evento). Contacta con soporte si hay que corregirla.",
    bgSectionTitle: "Imágenes de fondo",
    bgSlotAuth: "Fondo de inicio de sesión de invitado",
    bgSlotCountdown: "Fondo de cuenta regresiva",
    bgSlotRsvp: "Fondo de RSVP",
    bgUploaded: "Fondo subido",
    bgDeleted: "Fondo eliminado",
    bgUploadFailed: "Error al subir",
    bgDeleteFailed: "Error al eliminar",
    language: "Idioma de la App de Invitados",
    languageHint: "Establece el código de país predeterminado en la página de inicio de sesión.",
    languageSaved: "Idioma guardado",
    languageSaveFailed: "Error al guardar el idioma",
    bride: "Novia",
    groom: "Novio",
    enterBride: "Por favor ingresa el nombre de la novia",
    enterGroom: "Por favor ingresa el nombre del novio",
    manage: "Gestionar",
    slugAvailable: "Disponible",
    slugTaken: "Ya está en uso",
    slugChecking: "Verificando...",
    slugInvalidFormat: "Inválido (mín. 3 car., solo a-z 0-9 guiones)",
    nameLettersOnly: "Solo se permiten letras",
    locationInvalid: "Contiene caracteres no válidos",
    pkgWithGuests: "{{plan}} · hasta {{n}} invitados",
    pkgTrial: "{{plan}} (prueba) · {{n}} invitados",
    pkgAccountWide: "{{plan}} · toda la cuenta · {{n}} invitados",
    createAccountWideNotice: "Esta boda se abre sin paquete y usa el plan {{plan}} de tu cuenta (hasta {{n}} invitados).",
    applyTo: "Elige una boda",
    applyButton: "Asignar a esta boda",
    applied: "Paquete asignado a «{{title}}».",
    applyFailed: "No se pudo asignar el paquete, inténtalo de nuevo.",
    packageUnavailable: "Este paquete ya no está disponible (puede estar asignado a otra boda). La lista se actualizó.",
    packageForWedding: "Paquete de esta boda",
    packageChoiceHint: "Cada paquete es para una sola boda; los límites de la boda son los del paquete elegido.",
    freeSlotsFull: "No tienes ningún paquete disponible. Compra un paquete para una nueva boda.",
    createdWithPackage: "Boda creada y paquete asignado.",
    pkgFree: "{{plan}} · {{n}} invitados",
    pkgLegacy: "{{plan}} (transición) · {{n}} invitados",
    pkgSuspended: "Sin paquete — boda suspendida",
    walletAvailable: "Paquetes disponibles",
    walletNone: "Ninguno",
    walletInUse: "En uso: {{n}}",
    walletPending: "Pendientes de pago: {{n}}",
    walletLink: "Mis paquetes →",
    buyPackage: "Comprar un paquete",
    noPackageHint: "No tienes ningún paquete disponible para una nueva boda. Compra uno; aparecerá aquí cuando se confirme el pago.",
    packagePendingOption: "{{pkg}} · {{number}} — pago pendiente",
    createFreeNotice: "Esta boda se abre con el paquete {{plan}} (hasta {{n}} invitados). Puedes mejorarla después asignando un paquete de pago; el paquete Free se consume entonces.",
    startConsent: "Acepto que el servicio comience de inmediato, antes de que termine el plazo de desistimiento, y entiendo que no tengo derecho de desistimiento una vez asignado el paquete a esta boda.",
    packageRequired: "Elige un paquete para esta boda.",
    consentRequired: "Marca la casilla de consentimiento para un paquete de pago.",
    upgradeTitle: "Asigna un paquete disponible a una boda",
    upgradeHint: "Un paquete de pago mejora una boda con paquete Free o de transición (el paquete Free se consume entonces). Para cambiarlo después de asignarlo, contacta con soporte.",
    alreadyPaid: "Esta boda ya tiene un paquete de pago.",
    weddingHasPackage: "El paquete Free solo puede asignarse a una boda sin paquete (suspendida).",
  },
  profile: {
    title: "Mi Perfil",
    emailLabel: "Correo electrónico",
    nameLabel: "Nombre Completo",
    phoneLabel: "Teléfono",
    phoneLocked: "Contacta con soporte para cambiar tu número de teléfono.",
    memberSince: "Miembro desde {{date}}",
    loadFailed: "No se pudo cargar el perfil",
    updateSuccess: "Perfil actualizado",
    updateFailed: "Error al actualizar",
    deactivateTitle: "Desactivar cuenta",
    deactivateDesc: "Tu cuenta será suspendida. Se reactiva automáticamente al iniciar sesión con OTP.",
    deactivateConfirm: "Sí, desactivar",
    deactivateSuccess: "Cuenta desactivada. Redirigiendo...",
    deactivateFailed: "No se pudo desactivar la cuenta",
    dangerZone: "Zona de peligro",
    accountInfo: "Información de la cuenta",
    phoneChangeTitle: "Cambio de número de teléfono",
    phoneChangeAction: "Cambiar",
    phoneVerified: "Verificado",
    phoneNotVerified: "No verificado (necesario para SMS de prueba)",
    phoneVerifyAction: "Verificar",
    phoneVerifyTitle: "Verificar teléfono",
    phoneVerifyInfo: "Introduce el código de 6 dígitos enviado a {{phone}}.",
    phoneVerifyResend: "Reenviar",
    phoneVerifySubmit: "Verificar",
    phoneVerifySuccess: "Teléfono verificado",
    phoneChangeInfo: "Se creará una solicitud para cambiar tu número. Nuestro equipo la procesará lo antes posible.",
    phoneChangeSubject: "Solicitud de cambio de número de teléfono",
    phoneCurrent: "Actual",
    phoneChangeNew: "Nuevo",
    phoneNone: "Ninguno",
    phoneChangeAutoNote: "Esta solicitud fue creada automáticamente desde la página de perfil.",
    phoneChangeSubmit: "Enviar solicitud",
    phoneChangeSuccess: "Solicitud enviada",
    phoneChangeSuccessDesc: "Nuestro equipo verificará y actualizará tu número próximamente.",
    phoneChangeViewTicket: "Ver ticket",
    phoneChangeFailed: "Error al enviar la solicitud",
    phoneChangeRequired: "Por favor ingresa un nuevo número",
    phoneChangeFormat: "El número debe comenzar con el código de país (ej. +34612345678)",
    phoneChangeSame: "El nuevo número es igual al actual",
    accountPackages: "Cuenta y paquetes",
    packagesExplain: "Cada boda está vinculada a un paquete. Tu cuenta tiene un paquete Free; cada pedido pagado es un paquete nuevo. Tus paquetes y el historial de pedidos están en Mis paquetes.",
    accountWideBadge: "Toda la cuenta: {{plan}}",
    accountWideTitle: "Plan de la cuenta",
    accountWideExplain: "El plan {{plan}} propio de tu cuenta se aplica a las bodas sin paquete asignado. Los paquetes pagados son para una sola boda y fijan sus límites.",
    orderLegacy: "Transición (plan de cuenta anterior)",
    myOrders: "Mis pedidos",
    noOrders: "Aún no tienes pedidos.",
    orderPkg: "{{plan}} · hasta {{n}} invitados",
    orderWedding: "Boda: {{title}}",
    orderCancelled: "Cancelado",
    orderStatus: {
      pending: "Pago pendiente",
      paid: "Pagado",
      cancelled: "Cancelado",
    },
    buyPackage: "Comprar un paquete para una nueva boda",
    freeTitle: "Paquete Free",
    freeStatus: {
      available: "Disponible — puedes abrir una nueva boda",
      assigned: "En uso: {{title}}",
      ended: "Consumido — la boda pasó a un paquete de pago",
      used: "Usado",
    },
    packagesLink: "Mis paquetes",
  },
  rsvp: {
    title: "RSVP",
    welcomeGuest: "Bienvenido, {{name}}",
    shareStatus: "Díganos si asistirá",
    formTitle: "Formulario de Asistencia",
    formDescUpdate: "Puede actualizar su información",
    formDescNew: "Por favor complete sus datos",
    statusLabel: "Estado de Asistencia",
    statusYes: "Asistiré",
    statusMaybe: "Tal vez",
    statusNo: "No puedo asistir",
    headcountLabel: "Número de Personas",
    decreaseHeadcount: "Disminuir número de invitados",
    increaseHeadcount: "Aumentar número de invitados",
    dietLabel: "Preferencia Alimentaria",
    dietNone: "Sin restricciones",
    dietVegan: "Vegano",
    dietVegetarian: "Vegetariano",
    dietGlutenFree: "Sin gluten",
    dietOther: "Otro",
    notesLabel: "Notas (opcional)",
    notesPlaceholder: "Algún mensaje que quiera compartir...",
    submitting: "Enviando...",
    saved: "¡Guardado!",
    update: "Actualizar",
    submit: "Enviar",
    successUpdate: "¡Su respuesta ha sido actualizada!",
    successNew: "¡Su respuesta ha sido enviada!",
    thanks: "Gracias",
  },
  media: {
    uploadTitle: "Subir Foto / Video",
    uploadDesc: "Comparta sus recuerdos con nosotros",
    heicLocationNote: "La ubicación se elimina de las fotos antes de subirlas, pero no es posible con las fotos HEIC. Si no quieres incluir tu ubicación, elige la foto como JPEG o desactiva la ubicación de la cámara.",
    uploadCard: "Subir Medio",
    supportedFormats: "Se admiten archivos JPEG, PNG, HEIC, MP4, MOV",
    selectFile: "Seleccione un archivo o tome una foto",
    preview: "Vista previa",
    uploadBtn: "Subir",
    unsupportedType: "Tipo de archivo no compatible",
    fileTooLarge: "Archivo demasiado grande (máx. {{max}} MB)",
    uploadFailed: "Error al subir el archivo",
    uploadPartialError: "Algunos archivos no se pudieron subir.",
    errorTooLarge: "{{name}} es demasiado grande (máx. {{limit}} MB)",
    errorUnsupportedType: "{{name}} no está soportado (JPEG, PNG, HEIC, MP4, MOV)",
    videoLongWarning: "{{name}} dura unos {{duration}}s — los videos largos pueden tener problemas al subirse con conexión débil, se recomienda acortarlo.",
    retryFailed: "Reintentar",
    dropzoneDesc: "JPEG, PNG, HEIC, MP4, MOV admitidos",
    dropzone: "Seleccione un archivo o tome una foto",
    uploading: "Subiendo... ({{progress}}%)",
    uploadSuccess: "¡Subido! Aparecerá después de la moderación.",
    moderationNotice: "Sus archivos serán revisados antes de aparecer en la galería.",
    uploadTips: "Consejos",
    tip1: "Capture momentos espontáneos de la ceremonia",
    tip2: "Los clips cortos de 10 a 15 segundos funcionan mejor",
    tip3: "Se prefieren las fotos de alta calidad",
    submitBtn: "Enviar a la galería ({{count}})",
    noFilesSelected: "No hay archivos seleccionados",
    clearAll: "Borrar todo",
    addMore: "Agregar archivos",
    filesSelected: "Seleccionados ({{count}})",
    mine: {
      title: "Mis subidas ({{count}})",
      hint: "Aquí puedes retirar lo que hayas subido: se retira al instante, el organizador no puede recuperarlo y se borra definitivamente en 7 días.",
      pending: "Pendiente de aprobación",
      approved: "En la galería",
      delete: "Eliminar",
      deleteConfirm: "¿Quitar este contenido? Desaparece al instante de la galería y de la pantalla del salón y el organizador no puede recuperarlo; se borra definitivamente en 7 días.",
      deleted: "Eliminado",
      deleteFailed: "No se pudo eliminar: {{error}}",
    },
  },
  gallery: {
    title: "Galería",
    subtitle: "Recuerdos compartidos",
    empty: "Aún no hay medios compartidos",
    emptyHint: "¡Sea el primero en subir una foto!",
    selectedCount: "{{count}} seleccionado(s)",
    swipeHint: "Desliza para navegar",
    prev: "Anterior",
    next: "Siguiente",
    close: "Cerrar",
    allMedia: "Medios aprobados",
    favorites: "Favoritos",
    reviewQueue: "Cola de revisión",
    recycle: "Rechazados",
    newAlbum: "Nuevo álbum",
    albumName: "Nombre del álbum",
    createAlbum: "Crear álbum",
    deleteAlbum: "Eliminar álbum",
    deleteAlbumConfirm: "¿Está seguro de que desea eliminar este álbum? Los medios no se eliminarán.",
    renameAlbum: "Renombrar",
    addToAlbum: "Agregar al álbum",
    removeFromAlbum: "Eliminar del álbum",
    setCover: "Establecer como portada",
    selectMode: "Seleccionar",
    cancelSelect: "Cancelar selección",
    selected: "{{count}} seleccionado(s)",
    albumLimitReached: "Puede crear un máximo de 5 álbumes personalizados.",
    onlyApprovedCanBeAdded: "Solo los medios aprobados pueden añadirse a los álbumes.",
    noMedia: "Aún no hay medios.",
    noAlbumMedia: "No hay medios en este álbum.",
    loadMore: "Cargar más",
    itemCount: "{{count}} elementos",
    addedToFavorites: "Añadido a favoritos",
    removedFromFavorites: "Eliminado de favoritos",
    addedToAlbum: "Añadido al álbum",
    removedFromAlbum: "Eliminado del álbum",
    albumCreated: "Álbum creado",
    albumDeleted: "Álbum eliminado",
    albumRenamed: "Álbum renombrado",
    coverSet: "Foto de portada actualizada",
    like: "Me gusta",
    unlike: "Ya no me gusta",
    liked: "¡Me gusta!",
    commentAdded: "Comentario añadido",
    commentDeleted: "Comentario eliminado",
    deleteComment: "Eliminar comentario",
    noComments: "Sin comentarios aún",
    commentPlaceholder: "Añadir un comentario...",
    share: "Compartir",
    viewAllComments: "Ver los {{count}} comentarios",
    likesCount: "{{count}} me gusta",
    guest: "Invitado",
    doubleTapToLike: "Doble toque para dar me gusta",
    uploadPhotos: "Subir",
    searchByName: "Buscar por nombre de invitado...",
    filterNewest: "Más reciente",
    filterOldest: "Más antiguo",
    download: "Descargar",
    commentsCount: "{{count}} comentarios",
    uploadedBy: "Subido por {{name}}",
    noResults: "No se encontraron resultados",
    noResultsHint: "Prueba con un término de búsqueda diferente",
    albums: "Álbumes",
    noAlbums: "Sin álbumes",
    noPublicAlbums: "Ningún álbum compartido",
    noPublicAlbumsHint: "El organizador aún no ha publicado álbumes",
    backToAlbums: "Volver a álbumes",
    makePublic: "Hacer público",
    makePrivate: "Hacer privado",
    filterAll: "Todos",
    filterPhotos: "Fotos",
    filterVideos: "Vídeos",
    manageAlbums: "Gestionar álbumes",
    editAlbum: "Editar álbum",
    hideComment: "Ocultar comentario",
    unhideComment: "Mostrar comentario",
    commentHidden: "Oculto",
    commentHiddenSuccess: "Comentario oculto",
    commentUnhiddenSuccess: "Comentario visible",
    visibility: "Visibilidad",
    coverPhoto: "Foto de portada",
    public: "Público",
    private: "Privado",
    albumSaved: "Álbum guardado",
    addFromGallery: "Añadir desde galería",
    addSelected: "Añadir selección ({{count}})",
    alreadyInAlbum: "Ya en el álbum",
    removeFromAlbumConfirm: "¿Quitar?",
    searchGuest: "Buscar invitado...",
  },

  // ─── Activity Feed ──────────────────────────────
  activity: {
    title: "Actividad",
    all: "Todo",
    reactions: "Reacciones",
    uploads: "Publicaciones",
    likedOne: "le gustó una foto",
    likedOne_video: "le gustó un video",
    likedMany: "le gustaron {{count}} fotos",
    likedMany_video: "le gustaron {{count}} videos",
    commentedOne: "dejó un comentario",
    commentedMany: "dejó {{count}} comentarios",
    uploadedOne: "publicó una foto",
    uploadedOne_video: "publicó un video",
    uploadedMany: "publicó {{count}} fotos",
    uploadedMany_video: "publicó {{count}} videos",
    pendingOne: "1 foto pendiente de aprobación",
    pendingMany: "{{count}} fotos pendientes de aprobación",
    newActivity: "{{count}} nuevas actividades",
    empty: "Sin actividad aún",
    emptyHint: "¡Sé el primero en subir una foto!",
    justNow: "ahora mismo",
    minutesAgo: "hace {{count}}min",
    hoursAgo: "hace {{count}}h",
    daysAgo: "hace {{count}}d",
    you: "Tú",
    uploaded: "subió una foto",
    uploaded_video: "subió un video",
    liked: "le gustó una foto",
    liked_video: "le gustó un video",
    commented: "comentó",
    youUploadedOne: "subiste una foto",
    youUploadedOne_video: "subiste un video",
    youUploadedMany: "subiste {{count}} fotos",
    youUploadedMany_video: "subiste {{count}} videos",
    youLikedOne: "te gustó una foto",
    youLikedOne_video: "te gustó un video",
    youLikedMany: "te gustaron {{count}} fotos",
    youLikedMany_video: "te gustaron {{count}} videos",
    youCommentedOne: "comentaste",
    youCommentedMany: "dejaste {{count}} comentarios",
    unknownGuest: "Invitado",
    galleryBanner: "{{count}} nuevas actividades ↑",
    galleryBannerTap: "Toca para ver",
    toast: {
      newUpload: "{{name}} subió una foto 📸",
      newUpload_video: "{{name}} subió un video 🎥",
      newLike: "{{name}} le gustó una foto ❤️",
      newLike_video: "{{name}} le gustó un video ❤️",
      newComment: "{{name}} comentó 💬",
      see: "Ver →",
    },
  },
  slideshow: {
    title: "Escenario",
    live: "En vivo",
    connecting: "Conectando...",
    waiting: "Esperando el escenario...",
    waitingHint: "Las fotos aprobadas aparecerán aquí",
    sharedBy: "Compartido por {{name}}",
    memoriesInSync: "Recuerdos en sincronía",
    fullscreen: "Pantalla completa",
    exit: "Salir",
    exitFullscreen: "Minimizar",
    mute: "Silenciar",
    unmute: "Activar sonido",
    scanToJoin: "Únete a la celebración",
    scanToJoinHint: "Escanea para compartir fotos y enviar amor",
    tapToReact: "Envía un ❤️ desde tu teléfono",
    reactedOne: "{{name}} reaccionó",
    reactedOther: "{{name}} +{{count}} reaccionaron",
    idleHint: "Escanea el código para compartir tu primer recuerdo",
    watching: "viendo",
    presenceTitle: "Viendo ahora",
    presenceMore: "+{{count}} más",
    joined: "{{name}} se unió",
    rejiLive: "Reji en vivo",
    guestFallbackName: "Invitado",
  },
  slideshowRemote: {
    playing: "Reproduciendo",
    paused: "En pausa",
    slideOf: "{{current}} / {{total}}",
    viewers: "{{count}} viendo",
    pause: "Pausar",
    resume: "Reanudar",
    next: "Siguiente",
    previous: "Anterior",
    controlSuccess: "Comando enviado",
    controlFailed: "Error al enviar el comando",
    offline: "Escenario apagado",
  },
  reji: {
    title: "Reji",
    subtitle: "Cabina de dirección",
    live: "EN VIVO",
    idleNoViewers: "Esperando espectadores — escenario en espera",
    connecting: "Conectando...",
    watchMode: "Unirse al escenario",
    exitWatch: "Volver a Reji",
    flow: "Flujo",
    nowPlaying: "En escena",
    nextUp: "A continuación",
    hidden: "Oculto",
    hide: "Ocultar",
    unhide: "Restaurar",
    spotlight: "Destacar",
    gotoSuccess: "Saltado a la diapositiva",
    hideSuccess: "Oculto del espectáculo",
    unhideSuccess: "Restaurado al espectáculo",
    spotlightSuccess: "Destacado — a continuación",
    orderFirst: "Poner primero",
    moveNext: "Reproducir siguiente",
    moveEnd: "Mover al final",
    nudgeUp: "Subir",
    nudgeDown: "Bajar",
    presenceSheetTitle: "Espectadores",
    roleGuest: "Invitado",
    roleReji: "Reji",
    emptyPlaylist: "Sin medios aprobados",
    openReji: "Abrir Reji",
    dashboardStatus: "Estado del escenario",
  },
  admin: {
    watchSahne: "Ver Sahne",
    beVisible: "Hacerse visible",
    watchHidden: "Viendo oculto",
    watchOnly: "Solo ver",
    presenceName: "Administrador",
    forbidden: "Acceso Denegado",
    forbiddenDesc: "no está registrado como administrador de plataforma.",
    forbiddenHelp: "Contacte a un administrador de plataforma para obtener acceso.",
    switchAccount: "Iniciar sesión con otra cuenta",
    backToWeddings: "Volver a Todas las Bodas",
    usersTitle: "Usuarios (Organizadores)",
    usersDesc: "Gestiona los organizadores y los planes de la plataforma",
    weddingsDesc: "Gestiona y supervisa todas las bodas de la plataforma",
    packageColumn: "Paquete",
    packageAccountWide: "toda la cuenta",
    packageTrial: "Prueba",
    packageFree: "Paquete Free",
    packageLegacy: "transición",
    packageSuspended: "Suspendida (sin paquete)",
    accountPlanShort: "Cuenta: {{plan}}",
    accountPlanTitle: "Plan de la cuenta del organizador: solo se aplica a las bodas sin paquete; el paquete de esta boda está en la tarjeta del panel",
    usersTotal: "{{count}} organizadores en total",
    usersEmpty: "No hay usuarios registrados.",
    usersLoadFailed: "No se pudieron cargar los usuarios",
    planUpdateFailed: "No se pudo actualizar el plan",
    columnPlan: "Plan",
    columnWeddings: "Bodas",
    columnRegistered: "Registro",
    userDetail: "Detalle del Usuario",
    userWeddings: "Bodas del Usuario",
    noUserWeddings: "Este usuario no tiene bodas.",
    organizersTitle: "Organizadores",
    organizersEmpty: "No hay organizadores asignados a esta boda.",
    organizerRole: "Rol",
    organizerAccessHint: "Organizadores con acceso a esta boda",
    addOrganizer: "Añadir organizador",
    addFirstOrganizer: "Añadir primer organizador",
    organizerAdded: "Organizador añadido",
    organizerRemoved: "Organizador eliminado",
    removeOrganizer: "Eliminar organizador",
    removeOrganizerConfirm: "¿estás seguro de que deseas eliminar el acceso de este organizador?",
    // ─── Plans management ───────────────────────────
    plans: "Planes",
    addPlan: "Nuevo Plan",
    auditLog: "Registro de Auditoría",
    planDeleteConfirm: '¿Está seguro de que desea eliminar "{{slug}}"?',
    planFieldSlug: "Slug",
    planFieldLabel: "Etiqueta",
    planFieldSortOrder: "Orden",
    planFieldDefault: "Predeterminado",
    planFieldMaxWeddings: "Max Bodas",
    planFieldMaxGuests: "Max Invitados",
    planFieldMaxStorage: "Max Almacenamiento (GB)",
    planFieldMaxMedia: "Max Medios",
    planColLabel: "Etiqueta",
    planColSlug: "Slug",
    planColWeddings: "Bodas",
    planColGuests: "Invitados",
    planColStorage: "Almacenamiento",
    planColMedia: "Medios",
    planColUsers: "Usuarios",
    planColStatus: "Estado",
    planStatusDefault: "Predeterminado",
    planStatusActive: "Activo",
    planStatusInactive: "Inactivo",
    planHistory: "Historial",
    planChangeHistory: "Historial de Cambios",
    planNoHistory: "Sin historial de cambios",
    // ─── Audit log ──────────────────────────────────
    timeJustNow: "ahora mismo",
    timeMinutesAgo: "hace {{count}} min",
    timeHoursAgo: "hace {{count}} h",
    timeDaysAgo: "hace {{count}} día(s)",
    auditDescription: 'Todas las operaciones de escritura en la plataforma',
    auditFilterAction: 'Filtrar acción',
    auditSearchAction: 'Buscar acciones…',
    auditRecordCount: '{{count}} registros',
    auditTimeJustNow: 'ahora mismo',
    auditTimeMinutes: 'hace {{count}}m',
    auditTimeHours: 'hace {{count}}h',
    auditTimeDays: 'hace {{count}}d',
    auditActorAll: "Todos los Actores",
    auditActorAdmin: "Admin",
    auditActorOrganizer: "Organizador",
    auditActorGuest: "Invitado",
    auditActorSystem: "Sistema",
    auditActionsAll: "Todas las Acciones",
    auditSearchPlaceholder: "Buscar nombre, correo o ID...",
    auditNoResults: "No se encontraron registros",
    auditColTime: "Hora",
    auditColActor: "Actor",
    auditColIdentity: "Identidad",
    auditColAction: "Acción",
    auditColResource: "Recurso",
    auditColWeddingId: "ID Boda",
    auditGuestPrefix: "Invitado",
    auditLoadMore: "Cargar Más",
    auditMetadata: "Metadatos",
    auditMetadataNone: "No hay metadatos disponibles para este registro.",
  },
  web: {
    notFound: "Boda No Encontrada",
    weddingNotFound: "Boda No Encontrada",
    notFoundDesc: "La página de boda que busca no existe. Verifique su enlace de invitación.",
    invalidSlug: "Utilice su enlace de invitación para acceder.",
    useLinkPrompt: "Utilice su enlace de invitación para acceder.",
    appTitle: "Vite Gallery",
    notifications: "Notificaciones",
  },

  // ─── QR Self-Registration (Guest) ──────────────────
  join: {
    title: "Registro en la Boda",
    subtitle: "Introduce tus datos para unirte a la boda",
    namePlaceholder: "Nombre Apellido",
    nameLabel: "Nombre Apellido",
    submit: "Registrarse",
    submitting: "Registrando...",
    smsConsentLabel: "Quiero recibir SMS de invitación y recordatorio de la boda. (Puedes darte de baja en cualquier momento con el enlace del mensaje.)",
    alreadyRegistered: "¡Ya estás registrado!",
    alreadyRegisteredHint: "Este número ya está vinculado a esta boda. Pulsa el botón de abajo para iniciar sesión.",
    goToLogin: "Iniciar sesión",
    registrationClosed: "Registro cerrado",
    registrationClosedHint: "El registro de invitados no está activo para esta boda",
    registrationNotYet: "Registro aún no abierto",
    registrationOpensWeddingDay: "Estará activo el día de la boda",
    countdownDays: "días",
    countdownHours: "h",
    countdownMinutes: "min",
    countdownSeconds: "seg",
    successOtp: "Se ha enviado un código de verificación a tu teléfono",
    successAuthed: "¡Registro completado!",
    capReached: "Registro pausado temporalmente",
    capReachedHint: "Se alcanzó el límite de registros de hoy. Inténtalo más tarde o contacta con la pareja.",
    guestLimitReached: "Límite de invitados alcanzado",
    guestLimitReachedHint: "Esta boda alcanzó su límite de invitados. Avisa a los novios: pueden ampliarlo. Si estás en la lista, inicia sesión con tu teléfono.",
    foreignNumber: "Este número no se puede registrar.",
    foreignNumberHint: "El SMS de verificación solo puede enviarse a números que empiecen por {{prefixes}}. Contacta con la pareja para que te añadan a la lista.",
    invalidName: "Introduce tu nombre y apellidos — al menos 2 letras, sin números ni enlaces.",
  },

  // ─── Registration Settings (Organizer) ─────────────
  registration: {
    title: "Ajustes de Registro",
    allowSelfRegister: "Auto-registro",
    allowSelfRegisterHint: "Los invitados pueden registrarse escaneando el código QR",
    requireOtp: "Verificación OTP",
    requireOtpHint: "Si desactivado, introducir el teléfono es suficiente sin código",
    closedMode: "Cerrado permanentemente",
    closedModeHint: "Los invitados no pueden registrarse",
    scheduledMode: "Apertura programada",
    opensAt: "Apertura de registro",
    opensAtHint: "El registro se abrirá automáticamente en esta fecha y hora",
    opensAtRequired: "Por favor seleccione una fecha y hora de apertura",
    useWeddingTime: "Usar hora de la boda",
    closesAt: "Cierre del registro",
    closesAtHint: "Después de esta fecha el enlace QR deja de aceptar registros. Déjalo vacío para mantenerlo abierto.",
    closesAtClear: "Borrar",
    closesAtBeforeOpens: "El cierre debe ser posterior a la apertura",
    closesAtWeekAfterWedding: "1 semana después de la boda",
    incentiveTextPlaceholder: "Necesitamos su número de teléfono para poder compartir las fotos con usted después de la boda",
    save: "Guardar",
    saving: "Guardando...",
    saved: "Ajustes guardados",
    saveFailed: "Error al guardar",
    qrCode: "Código QR",
    qrCodeHint: "Los invitados escanean este código QR para registrarse",
    qrDownload: "Descargar PNG",
    qrDownloadSvg: "Descargar SVG",
    qrDownloadPdf: "Descargar PDF",
    qrCtaShare: "Comparte tus fotos",
    qrCopyUrl: "Copiar URL",
    qrCopied: "¡Copiado!",
    sourceOrganizer: "Añadido manualmente",
    sourceQr: "Registrado por QR",
    weddingDetails: "Detalles de la boda",
    weddingDetailsHint: "Controla qué campos pueden rellenar los invitados durante el RSVP",
    showDietField: "Preferencia alimentaria",
    showDietFieldHint: "Recopila las restricciones dietéticas de los invitados",
    showNotesField: "Solicitudes especiales",
    showNotesFieldHint: "Permite a los invitados añadir una nota",
    maxHeadcount: "Personas por RSVP",
    maxHeadcountHint: "Número máximo de personas por respuesta RSVP",
  },

  // ─── Support Tickets ───────────────────────────────
  support: {
    title: "Tickets de Soporte",
    newTicket: "Abrir Ticket",
    subject: "Asunto",
    body: "Descripción",
    status: "Estado",

    noTickets: "No hay tickets de soporte aún.",
    selectTicket: "Selecciona un ticket",
    selectTicketHint: "o abre una nueva solicitud de soporte",
    statusOpen: "Abierto",
    statusInReview: "En revisión",
    statusResolved: "Resuelto",
    statusClosed: "Cerrado",
    submit: "Enviar",
    submitting: "Enviando...",
    successCreate: "Tu ticket de soporte ha sido enviado.",
    settingsSaved: "Guardado",
    backToList: "Volver a tickets",
    weddingLabel: "Boda relacionada",
    generalTicket: "General (no específico de una boda)",
    minCharsSubject: "El asunto debe tener al menos 5 caracteres",
    minCharsBody: "La descripción debe tener al menos 20 caracteres",
    replyPlaceholder: "Escribe tu mensaje...",
    sendMessage: "Enviar",
    sending: "Enviando...",
    ticketClosed: "Este ticket está cerrado, no se pueden enviar nuevos mensajes.",
    you: "Tú",
    admin: "Equipo de soporte",
    unreadDot: "Nuevo mensaje",
    priorityLow: "Baja",
    priorityNormal: "Normal",
    priorityHigh: "Alta",
    priorityUrgent: "Urgente",
    categoryGeneral: "General",
    categoryBilling: "Facturación",
    categoryTechnical: "Técnico",
    categoryBug: "Informe de error",
    categoryFeatureRequest: "Solicitud de función",
    priority: "Prioridad",
    category: "Categoría",
    internalNote: "Nota interna",
    internalNoteHint: "Esta nota solo es visible para el equipo admin, no para el organizador.",
    sendAndResolve: "Enviar y resolver",
    reopen: "Reabrir",
    reopenConfirm: "Este ticket se reabrirá. ¿Estás seguro?",
    csatTitle: "Valora tu experiencia de soporte",
    csatHint: "Este ticket está resuelto. Puedes valorar tu experiencia del 1 al 5.",
    csatSubmit: "Enviar valoración",
    csatThanks: "¡Gracias por tu comentario!",
    csatAlreadyRated: "Ya has valorado este ticket.",
    cannedResponses: "Respuestas predefinidas",
    cannedResponsesEmpty: "Aún no hay respuestas predefinidas.",
    addCannedResponse: "Agregar respuesta",
    cannedTitle: "Título",
    cannedContent: "Contenido",
    deleteCannedConfirm: "Esta respuesta será eliminada. ¿Estás seguro?",
    insertCanned: "Insertar respuesta predefinida",
    attachments: "Archivos adjuntos",
    attachmentHint: "Hasta 2 fotos, máx 5 MB cada una (JPEG, PNG, WebP, GIF)",
    attachmentUploading: "Subiendo...",
    attachmentError: "Error al subir el archivo",
    removeAttachment: "Eliminar adjunto",
    ticketNumber: "Ticket #{{number}}",
    sendNotification: "Enviar notificación",
    noNotification: "Sin notificación",
    monthlyLimitReached: "Has alcanzado el límite mensual de tickets (máx. 10/mes).",
    csatRated: "Valorados",
    csatUnrated: "Sin valorar",
    tabActive: "Activo",
    tabResolved: "Resuelto",
    attachFiles: "Adjuntar archivos",
    fileTypeError: "Solo se admiten archivos JPEG, PNG, WebP y GIF.",
    fileSizeError: "Cada archivo debe tener como máximo 5 MB.",
  },
  adminSupport: {
    title: "Tickets de Soporte",
    settings: "Configuración de Soporte",
    allTickets: "Todos los Tickets",
    noTickets: "No hay tickets de soporte.",
    from: "De",
    replyPlaceholder: "Escribe tu respuesta...",
    saveReply: "Guardar respuesta",
    saving: "Guardando...",
    updateStatus: "Actualizar estado",
    settingsTitle: "Configuración de Soporte",
    emailLabel: "Dirección de correo de notificación",
    sendMessage: "Enviar",
    sending: "Enviando...",
    unreadDot: "Nuevo mensaje",
  },
  sms: {
    title: "Invitaciones SMS",
    description: "Envía SMS de invitación y recordatorio de RSVP a tus invitados",
    quotaLabel: "Envíos restantes",
    quotaExhausted: "No te quedan envíos",
    smsQuotaLabel: "Créditos SMS restantes",
    smsQuotaExhausted: "No te quedan créditos SMS",
    channelDisabled: "El envío de SMS ha sido desactivado temporalmente por el administrador. Tus campañas programadas se enviarán automáticamente cuando se reactive el canal.",
    campaignsDisabled: "El administrador aún no ha activado las campañas SMS. Tus campañas programadas se enviarán automáticamente cuando se activen.",
    sendDisabledHint: "El envío de SMS está desactivado por el administrador — no se puede enviar.",
    newCampaign: "Nueva campaña",
    nameLabel: "Nombre de la campaña",
    namePlaceholder: "p. ej. Primera invitación",
    templateLabel: "Plantilla del mensaje",
    defaultTemplate: "Estimado/a {{guest_name}}, nos encantaría contar con usted en la boda de {{couple_names}} el {{date}}. Confirme aquí: {{rsvp_link}}",
    previewLabel: "Vista previa",
    previewEmpty: "Tu mensaje aparecerá aquí",
    sampleGuest: "María García",
    segmentInfo: "{{chars}} caracteres · {{segments}} segmento(s) SMS",
    ucs2Hint: "(los caracteres especiales reducen cada segmento a 70 caracteres)",
    segmentLabel: "¿Quién lo recibe?",
    segments: {
      all: "Todos los invitados",
      rsvp_none: "Sin RSVP",
      rsvp_no: "Rechazaron",
      rsvp_maybe: "Indecisos",
      manual: "Elegir manualmente",
    },
    recipientCount: "{{count}} destinatario(s)",
    searchGuests: "Buscar invitado…",
    selectedCount: "{{count}} seleccionado(s)",
    noGuests: "No se encontraron invitados",
    scheduleLabel: "¿Cuándo se envía?",
    schedules: {
      now: "Enviar ahora",
      scheduled: "Programar",
      auto_chain: "Recordatorio automático",
    },
    scheduledAtLabel: "Hora de envío",
    chainDaysLabel: "Días de intervalo",
    chainRoundsLabel: "Rondas máx.",
    chainHint: "Cada ronda solo llega a los invitados que aún no han respondido; quien responde sale automáticamente de la cadena.",
    testPhonePlaceholder: "+34…",
    sendTest: "Enviar prueba",
    testHint: "Se envía a tu número verificado (verifícalo en Perfil).",
    testDisabledAdminHint: "Los administradores no tienen un número de teléfono verificado registrado — el envío de prueba no está disponible aquí.",
    goToControlCenter: "Ir al centro de control",
    excludedNoConsent: "{{count}} sin consentimiento",
    testSent: "SMS de prueba enviado",
    costEstimate: "Costo estimado: ~${{cost}}",
    submitNow: "Enviar",
    submitSchedule: "Programar",
    created: "Campaña creada",
    canceled: "Campaña cancelada",
    delete: "Eliminar",
    deleteConfirm: "Esta campaña se eliminará permanentemente. ¿Estás seguro?",
    deleted: "Campaña eliminada",
    cancel: "Cancelar",
    details: "Detalles",
    history: "Historial de campañas",
    noCampaigns: "Aún no hay campañas. Envía tu primera invitación arriba.",
    roundsUsed: "{{count}} ronda(s)",
    nextRound: "siguiente: {{date}}",
    held: "En espera",
    holdBadge: "En espera",
    holdReasons: {
      channel_disabled: "En espera porque un administrador desactivó temporalmente el envío de SMS. Se enviará automáticamente cuando se reactive.",
      campaigns_disabled: "En espera porque un administrador aún no ha habilitado las campañas de SMS. Se enviará automáticamente cuando lo haga.",
      not_configured: "En espera porque el envío de SMS todavía no está configurado — ponte en contacto con un administrador.",
      spend_breaker: "En espera porque se activó un límite de gasto de seguridad. Se enviará automáticamente cuando un administrador lo restablezca.",
      daily_cap: "En espera porque se alcanzó el límite diario de envíos. Se enviará automáticamente cuando el límite se restablezca.",
    },
    approval: {
      pendingBadge: "Pendiente de aprobación",
      approvedBadge: "Aprobada",
      rejectedBadge: "Rechazada",
      pendingHint: "Esta lista de {{count}} personas supera el umbral, así que espera la aprobación de un administrador. Se enviará automáticamente una vez aprobada.",
      rejectedHint: "Un administrador rechazó esta campaña; no se enviará nada. Puedes crear una nueva campaña con un segmento más pequeño.",
      rejectedHintWithReason: "Rechazada por un administrador: {{reason}}",
      createdPending: "Tu campaña se creó — la lista de {{count}} personas supera el umbral, así que espera la aprobación de un administrador. Se enviará automáticamente una vez aprobada.",
      pageTitle: "Aprobaciones de SMS",
      pageDescription: "Las campañas por encima del umbral esperan aquí — no sale ni un SMS hasta que se aprueben.",
      empty: "No hay campañas pendientes de aprobación",
      emptyHint: "Toda campaña cuyo número de destinatarios supere el umbral llega aquí automáticamente.",
      thresholdNote: "Umbral actual: {{count}} destinatarios. Se puede cambiar en el Centro de Control.",
      recipients: "{{count}} destinatario(s)",
      recipientsUnknown: "No se pudo determinar el número de destinatarios (se pide aprobación por precaución)",
      estimatedCost: "Coste estimado",
      segmentsPerMessage: "{{count}} segmento(s) por mensaje",
      wedding: "Boda",
      organizer: "Organizador",
      createdAt: "Creada",
      scheduledFor: "Envío programado",
      sendNowLabel: "Inmediatamente (pendiente de aprobación)",
      messagePreview: "Vista previa del mensaje",
      approve: "Aprobar",
      reject: "Rechazar",
      approving: "Aprobando…",
      rejecting: "Rechazando…",
      rejectReasonLabel: "Motivo del rechazo (opcional)",
      rejectReasonPlaceholder: "p. ej. lista demasiado grande, hay que acotar el segmento",
      rejectCancel: "Cancelar",
      rejectConfirm: "Rechazar",
      approveSuccess: "Campaña aprobada — el envío se ha liberado.",
      rejectSuccess: "Campaña rechazada — no se enviará nada.",
      actionError: "No se pudo completar la acción",
      loadMore: "Cargar más",
    },
    round: "Ronda {{n}}",
    noSendsYet: "Nada enviado todavía.",
    center: {
      pageTitle: "Centro SMS",
      pageDescription: "Campañas SMS de todas las bodas: cola de aprobación y gasto real.",
      tabPending: "Pendientes de aprobación",
      tabAll: "Todas las campañas",
      filterWedding: "Boda",
      filterWeddingAll: "Todas las bodas",
      filterStatus: "Estado",
      filterStatusAll: "Todos los estados",
      filterApproval: "Aprobación",
      filterApprovalAll: "Todos los estados de aprobación",
      filterApprovalNone: "Nunca requirió aprobación",
      filterIncludeDeleted: "Mostrar eliminadas",
      filterReset: "Limpiar filtros",
      pageTotals: "{{count}} campañas en esta página · {{segments}} segmentos · ~${{usd}}",
      empty: "Sin campañas",
      emptyHint: "Todavía no se ha creado ninguna campaña SMS en ninguna boda.",
      emptyFiltered: "Ninguna campaña coincide con los filtros seleccionados.",
      deletedBadge: "Eliminada",
      spent: "Gastado",
      segmentsUsed: "{{count}} segmentos",
      sends: "Envíos",
      deliveredFailed: "{{delivered}} entregados · {{failed}} fallidos",
      audience: "Audiencia",
      lastDispatch: "Último envío",
      nextDispatch: "Siguiente: {{at}}",
      rejectionReason: "Motivo del rechazo: {{reason}}",
      createdAt: "Creada: {{at}}",
      unitPrice: "unidad ${{usd}}",
    },
    status: {
      scheduled: "Programada",
      active: "Activa",
      dispatching: "Enviando",
      completed: "Completada",
      canceled: "Cancelada",
      failed: "Error",
    },
    sendStatus: {
      queued: "En cola",
      sent: "Enviado",
      delivered: "Entregado",
      failed: "Fallido",
      undelivered: "No entregado",
    },
    table: {
      guest: "Invitado",
      phone: "Teléfono",
      round: "Ronda",
      status: "Estado",
    },
  },

  errorBoundary: {
    title: "Hubo un problema al abrir esta página",
    desc: "Las demás páginas siguen funcionando. Recarga la página; si se repite, envíanos el detalle.",
    reload: "Recargar página",
    details: "Detalle técnico",
  },
  controlCenter: {
    loadPartialFailed: "No se pudieron cargar {{count}} fuentes de datos — lo mostrado puede estar incompleto.",
    accountsPrivacy: {
      title: "Cuentas y privacidad",
    },
    title: "Centro de control",
    description: "Interruptores de emergencia, límites financieros, gasto en SMS y registros de envío",
    type: "Tipo",
    killSwitch: "Interruptor de emergencia",
    group: {
      sms: "SMS",
      other: "Otros",
    },
    smsEnabled: "SMS — Interruptor principal",
    smsEnabledDesc: "Detiene todo SMS, campañas + OTP incluidos (principal).",
    emailEnabled: "Correo — Interruptor principal",
    emailEnabledDesc: "Todo el envío de correo (OTP, alertas, soporte).",
    smsCampaignsEnabled: "SMS Campañas",
    smsCampaignsDesc: "SMS de invitación/recordatorio; no afecta el acceso (OTP).",
    masterBadge: "TODO",
    enabled: "Activado",
    disabled: "Desactivado",
    configSaved: "Configuración guardada",
    stats: "Estadísticas",
    sms24h: "SMS (24h)",
    email24h: "Correo (24h)",
    failed24h: "Fallidos (24h)",
    blocked24h: "Bloqueados (24h)",
    sms7d: "SMS (7d)",
    email7d: "Correo (7d)",
    logs: "Registro de envíos",
    recipient: "Destinatario",
    status: "Estado",
    error: "Error",
    weddingId: "Boda",
    createdAt: "Fecha",
    noLogs: "No se encontraron registros.",
    loadMore: "Cargar más",
    filters: {
      all: "Todos",
      sms: "SMS",
      email: "Correo",
      sent: "Enviado",
      failed: "Fallido",
      blocked: "Bloqueado",
    },
    campaigns: {
      title: "Campañas SMS",
      active: "Campañas activas",
      sends24h: "Envíos (24h)",
      failed24h: "Fallidos (24h)",
      sends7d: "Envíos (7d)",
      held: "{{count}} ronda(s) en espera",
      pendingApproval: "{{count}} campaña(s) pendiente(s) de aprobación",
      reviewLink: "Abrir la cola de aprobación",
    },
    spend: {
      title: "Gasto SMS",
      segments: "Segmentos (hoy)",
      estCost: "Costo estimado",
      breaker: "Interruptor",
      tripped: "Interruptor de gasto activado ({{reason}}) — envío de campañas detenido.",
      reset: "Restablecer",
      resetDone: "Disyuntor reiniciado",
    },
  },

  finance: {
    title: "Límites financieros",
    capsTitle: "Límites (caps)",
    capsHint: "Edita los valores — solo se guardan los campos modificados. El servidor valida los límites finales.",
    save: "Guardar",
    override: "Personalizado",
    default: "Predeterminado",
    resetField: "Restablecer al predeterminado",
    resetToDefault: "Restablecer al predeterminado",
    unitMb: "MB",
    unitUsd: "USD",
    rangeHint: "Debe estar entre {{min}} y {{max}}",
    saveSuccess: "Límites financieros actualizados",
    resetSuccess: "Restablecido al predeterminado",
    boundsError: "El valor está fuera del rango permitido",
    switchEnabled: "Activado",
    switchDisabled: "Desactivado",
    caps: {
      verifyDailyCap: "Límite diario de Verify (OTP)",
      smsSegmentDailyCap: "Límite diario de segmentos SMS",
      smsPreviewDailyCap: "Límite diario de vista previa SMS",
      smsRoundRecipientHardCap: "Límite de destinatarios por ronda",
      smsManualSegmentMaxGuests: "Segmento manual máx. invitados",
      emailDailyCap: "Límite diario de correo",
      smsTrPriceUsd: "Precio unitario SMS (TR)",
      maxImageBytes: "Tamaño máx. de foto",
      maxVideoDirectBytes: "Tamaño máx. de video (directo)",
      qrScanVisitorDailyCap: "Escaneos QR diarios por visitante",
      selfRegisterDailyCap: "Registros QR diarios por boda",
      smsApprovalThreshold: "Umbral de aprobación de SMS (destinatarios)",
    },
    capsDesc: {
      selfRegisterDailyCap: "Número máximo de registros que una boda acepta desde su enlace QR/join en 24 horas. El enlace es público, así que si se filtra o pasa un bot, la lista de invitados y el presupuesto de SMS OTP se detienen aquí; superado el límite se rechazan los nuevos registros y se envía un aviso al canal de administración. Los invitados añadidos manualmente no cuentan.",
      smsApprovalThreshold: "Si el número de destinatarios de una campaña SUPERA este valor, la campaña se crea pero no sale ni un SMS hasta que un administrador la apruebe. 0 = toda campaña requiere aprobación (modo bloqueo), 5000 = prácticamente desactivado. Las campañas por debajo del umbral salen automáticamente como antes.",
      qrScanVisitorDailyCap: "Cuántas filas de escaneo QR puede escribir un mismo dispositivo al día. La identidad es un hash de boda + IP + navegador (user-agent) + día — no solo la IP, así que cada dispositivo en el WiFi compartido del lugar tiene su propia cuota. Los escaneos por encima del límite no se guardan (el invitado igual es redirigido).",
    },
    switchesTitle: "Interruptores de apagado",
    switchesHint: "Todos ACTIVADOS por defecto. Apagar los peligrosos requiere confirmación.",
    switches: {
      verifyEnabled: "Acceso SMS (OTP)",
      uploadsEnabled: "Subidas de medios",
      imageTransformEnabled: "Redimensión CDN",
      smsApprovalEnabled: "Barrera de aprobación de SMS",
      organizerSeesGuestDeletedMedia: "El organizador ve lo que quitaron los invitados",
    },
    switchesDesc: {
      smsApprovalEnabled: "⚠️ A DIFERENCIA de los demás: ACTIVADO = la barrera está en marcha (las campañas por encima del umbral esperan aprobación). Desactivarla elimina por completo el requisito de aprobación — las campañas por encima del umbral salen directamente.",
      verifyEnabled: "Códigos de acceso SMS de invitado/organizador; no afecta campañas.",
      uploadsEnabled: "Fotos/videos de invitados; apagarlo detiene todas las subidas.",
      imageTransformEnabled: "Redimensión de imagen al vuelo. Seguro — no afecta las subidas.",
      organizerSeesGuestDeletedMedia: "Activado: el contenido que un invitado quitó aparece en solo lectura en la lista “Eliminados” del organizador (no se puede restaurar). Desactivado (predeterminado): solo lo ve el administrador de la plataforma.",
    },
    monitoringTitle: "Monitoreo en vivo",
    mon: {
      verify: "Verify (hoy)",
      segments: "Segmentos SMS (hoy)",
      breaker: "Interruptor de gasto",
      breakerOk: "Normal",
      breakerTripped: "Activado",
    },
    confirm: {
      title: "Acción peligrosa",
      verifyWarning: "Si se apaga Verify, invitados/organizadores no pueden iniciar sesión por SMS.",
      uploadsWarning: "Si se apagan las subidas, los invitados no pueden subir fotos.",
      detail: "Puedes volver a activar este ajuste en cualquier momento.",
      turnOff: "Apagar",
      approvalWarning: "Si se desactiva la puerta de aprobación, las campañas SMS por encima del umbral se envían sin aprobación.",
    },
  },

  maintenance: {
    title: "Seguimiento de errores",
    overview: "Resumen",
    totalGroups: "Total de grupos de errores",
    unresolved: "Sin resolver",
    last24h: "Últimas 24 horas",
    last7d: "Últimos 7 días",
    topRoutes: "Rutas más frecuentes",
    errorGroups: "Grupos de errores",
    events: "Eventos",
    markResolved: "Marcar resuelto",
    markUnresolved: "Reabrir",
    resolutionNote: "Nota de resolución",
    resolutionSaved: "Guardado",
    firstSeen: "Primera vez",
    lastSeen: "Última vez",
    totalCount: "Total",
    requestId: "ID de solicitud",
    purge: "Purgar registros antiguos",
    purgeConfirm: "Todos los registros de más de 30 días serán eliminados. ¿Continuar?",
    purgeDetail: "Elimina registros de más de 30 días de error_log + error_groups. Un cron job lo ejecuta automáticamente cada noche a las 03:00.",
    purged: "Registros antiguos purgados",
    stackTrace: "Stack Trace",
    noErrors: "No se encontraron errores.",
    groupNotFound: "Grupo de errores no encontrado.",
    description: "Grupos de errores y monitoreo de salud del sistema",
    statusResolved: "Resuelto",
    statusOpen: "Abierto",
    colLastSeen: "Visto por última vez",
    colKind: "Tipo",
    colMethod: "Método",
    colPath: "Ruta",
    colError: "Error",
    colCount: "Cantidad",
    message: "Mensaje",
    dateLabel: "Fecha",
    weddingLabel: "Boda",
    actorLabel: "Actor",
    timeJustNow: "ahora mismo",
    timeMinutes: "{{count}}min",
    timeHours: "{{count}}h",
    timeDays: "{{count}}d",
    kind: {
      exception: "Excepción",
      soft: "Error suave",
    },
    filters: {
      all: "Todos",
      unresolvedOnly: "Solo abiertos",
      pathSearch: "Buscar ruta… (Enter)",
    },
  },
  // ─── Home Feed (Guest) ─────────────────────────────
  home: {
    rsvpNudge: "¿Asistirás a la boda?",
    rsvpNudgeAction: "Responder",
    rsvpNudgeTitle: "¡Te esperamos!",
    rsvpNudgeText: "Por favor confirma tu asistencia para ayudarnos a planificar.",
    rsvpNudgeRespond: "Responder ahora",
    newActivity: "{{count}} nuevos momentos compartidos",
    topLiked: "Más amadas",
    recentActivity: "Actividad reciente",
    seeAll: "Ver todo",
    viewGallery: "Ver galería",
    welcomeBack: "Bienvenido, {{name}}",
    rsvpStatus: "Tu estado RSVP",
    rsvpNotResponded: "Aún no has respondido",
    partyOf: "{{count}} persona(s)",
    weddingDetails: "Detalles de la boda",
    dateTime: "Fecha y hora",
    venue: "Lugar",
    updateRsvp: "Actualizar",
    respondNow: "Responder ahora",
    noMediaYet: "Aún no hay fotos compartidas",
    noMediaYetHint: "¡Sé el primero en subir una foto!",
    noActivityYet: "Aún no hay actividad",
    empty: "Sin actividad aún. ¡Sé el primero en subir una foto!",
    countdown: {
      daysLeft: "días para la boda",
      daysAgo: "días desde la boda",
      dayUnit: "Días",
      hoursUnit: "H",
      minsUnit: "Min",
      secsUnit: "Seg",
      label: "Cuenta Regresiva",
      labelFor: "{{event}} — Cuenta regresiva",
      todayFor: "¡Hoy es {{event}}!",
      today: "¡Hoy es el día de la boda!",
    },
  },

  themes: {
    title: "Temas",
    description: "Fondos predeterminados utilizados en toda la plataforma. Los organizadores pueden personalizarlos por boda.",
    backgrounds: "Fondos",
    slotGuestAuth: "Inicio de sesión de invitado",
    slotOrganizerAuth: "Inicio de sesión del organizador",
    slotGuestCountdown: "Cuenta regresiva",
    slotGuestRsvp: "RSVP",
    slotGuestAuthDesc: "Fondo que se muestra en la pantalla de inicio de sesión de la app de invitados",
    slotOrganizerAuthDesc: "Fondo que se muestra en la pantalla de inicio de sesión del panel del organizador",
    slotGuestCountdownDesc: "Fondo que se muestra en la página de cuenta atrás antes de la boda",
    slotGuestRsvpDesc: "Fondo que se muestra en la página de RSVP de invitados",
    upload: "Subir",
    change: "Cambiar",
    deleteSlot: "Eliminar",
    uploaded: "Subido",
    deleted: "Eliminado",
    uploadFailed: "Error al subir",
    deleteFailed: "Error al eliminar",
    noBackground: "Sin fondo",
    dragDrop: "Haz clic o arrastra para subir una imagen",
    fileHint: "Máx. 10MB · JPEG, PNG, WebP, AVIF · Recomendado 1920×1080",
    active: "Activo",
    confirmDelete: "¿Estás seguro de que deseas eliminar este fondo?",
    // ─── Join Themes (Organizer) ──────────────────────
    presets: "Temas predefinidos",
    customize: "Personalizar",
    palette: "Paleta de colores",
    fontPair: "Par de fuentes",
    images: "Imágenes",
    heroImage: "Imagen principal",
    heroImageHint: "Fondo de la página de invitación",
    gallery: "Galería",
    galleryHint: "Máx. 5 fotos",
    preview: "Vista previa",
    publish: "Publicar",
    customized: "Personalizado",
    reset: "Restablecer",
    saveSuccess: "Tema guardado",
    saveError: "Error al guardar",
    uploadError: "Error al subir",
    deleteError: "Error al eliminar",
    fontPairHeadingPreview: "Título de la boda",
    fontPairBodyPreview: "Vista previa del texto de invitación",
    heroImageDesc: "La imagen de fondo a pantalla completa que los invitados ven al abrir el enlace. Usa el degradado del tema si no se define.",
    galleryDesc: "Fotos mostradas en la sección de galería. Déjelo vacío para ocultar la galería.",
    joinTitle: "Tema de la página de invitación",
    joinSubtitle: "Personaliza el aspecto de la página que ven tus invitados.",
    previewCoupleName: "Emma & Carlos",
    previewDateLocation: "12 de septiembre 2026 · Madrid",
    previewJoinTitle: "Únete a nosotros",
    previewJoinSubtitle: "Solo tu nombre y teléfono para aceptar la invitación.",
    previewRegisterBtn: "Registrarse",
    uploadTooLarge: "Archivo demasiado grande. Máximo 10 MB por foto.",
    uploadInvalidType: "Solo se permiten fotos en formato JPEG, PNG, WebP o AVIF.",
    videoSection: "Animación de desplazamiento",
    videoDesc: "Al desplazarse, el video avanza fotograma a fotograma. Sube un archivo MP4 o WebM.",
    videoUpload: "Subir video",
    videoExtracting: "Extrayendo fotogramas...",
    videoUploading: "Subiendo...",
    videoProgress: "{{done}} / {{total}} fotogramas",
    videoFrameCount: "{{count}} fotogramas listos",
    videoRemove: "Eliminar animación",
    videoSuccess: "Animación lista",
    videoError: "Error al procesar el video",
    videoInvalidType: "Solo se permiten archivos MP4 o WebM.",
    videoTooLarge: "Video demasiado grande. Máximo 200 MB.",
    deleteImageConfirm: "¿Estás seguro de que quieres eliminar esta imagen?",
    deleteVideoConfirm: "¿Estás seguro de que quieres eliminar la animación? Se eliminarán todos los fotogramas.",
    mobile: "Móvil",
    desktop: "Escritorio",
    noHero: "Sin imagen",
    addImage: "Agregar imagen",
    changeImage: "Cambiar",
    layoutPickerTitle: "Diseño del tema",
    layoutPickerSubtitle: "Elige el diseño clásico o uno de los temas premium. Los temas editables permiten personalizar todos los textos e imágenes.",
    layoutEditorTitle: "Ajustes del tema",
    layoutEditorSubtitle: "Personaliza textos, imágenes y colores.",
    // ─── Layout picker grupo/estado + nombres de tema ──
    layoutGroupClassic: "Clásico",
    layoutGroupPremium: "Premium",
    layoutStatusEditable: "Editable",
    layoutStatusClassic: "Tema clásico",
    layoutStatusPreview: "Vista previa",
    layoutNames: {
      default: "Clásico (predeterminado)",
      cinematic: "Cinematográfico",
      minimal: "Minimalista",
      parallax: "Parallax romántico",
      editorial: "Editorial en negrita",
      "dark-romance": "Romance oscuro",
    },
  },

  // ─── Landing (sitio de marketing, `/`) ─────────────
  // ─── Baskı (ortak paket @wedding/print-kit) ─────────
  printKit: {
    title: "Impresión",
    description: "Tarjetas QR para tu boda — con los nombres, la fecha y tu propio código QR. «Imprimir / PDF» genera un PDF a tamaño real para la imprenta.",
    nameA: "Primer nombre",
    nameB: "Segundo nombre",
    date: "Fecha",
    tables: "Números de mesa",
    tablesHint: "P. ej. 1-20, VIP — una página por mesa (máximo {{max}}).",
    tableCard: "Tarjeta de mesa",
    tableCardSize: "A6 · 105 × 148 mm",
    welcomeSign: "Cartel de bienvenida",
    welcomeSignSize: "50 × 70 cm",
    handCard: "Tarjeta de mano",
    handCardSize: "85 × 55 mm",
    pages: "{{count}} páginas",
    print: "Imprimir / PDF",
    printing: "Se abrió el diálogo de impresión — elige «Guardar como PDF».",
    printFailed: "No se pudo abrir el diálogo de impresión.",
    qrTarget: "El QR abre:",
    langNote: "textos en el idioma de la boda ({{lang}})",
    tip: "Consejo: escanea el QR de una impresión de prueba antes de enviarlo a la imprenta. Mantén activados los «Gráficos de fondo».",
    tpl: {
      shareEyebrow: "Comparte tus recuerdos con nosotros",
      step1: "Escanea",
      step2: "Comparte",
      step3: "Míralo en pantalla",
      table: "Mesa",
      welcome: "Bienvenidos",
      headlineA: "Cada instante de esta noche",
      headlineB: "está en tus manos.",
      captionStrong: "Escanea con tu cámara,",
      caption: "comparte tus fotos y vídeos — aparecen en la pantalla grande en segundos.",
      noApp: "No necesitas ninguna app",
      handEyebrow: "Esta noche",
      handLine1: "uno de los instantes",
      handLine2: "es tuyo.",
      handSteps: "Escanea · Comparte · Mira",
    },
  },

  // ─── Canlı demo girişi (web, F7) ─────────
  demoEnter: {
    title: "Bienvenido a la demo en vivo",
    body: "Explora como invitado: sube fotos, deja corazones, abre Sahne. No necesitas número de teléfono.",
    nameLabel: "Tu nombre (opcional)",
    namePlaceholder: "P. ej. Deniz",
    submit: "Unirse a la demo",
    entering: "Entrando…",
    note: "Lo que subas pasa por moderación, nunca es público y se borra cada noche.",
    failed: "No se pudo entrar a la demo ahora — inténtalo en un momento.",
    capReached: "La demo está muy concurrida hoy — inténtalo mañana.",
  },

  // ─── Albümü indir (ortak paket @wedding/album-export) ─────────
  albumExport: {
    button: "Descargar álbum",
    meta: "{{count}} elementos · {{size}}",
    empty: "Aún no hay fotos aprobadas.",
    onlyApproved: "Solo fotos aprobadas, en calidad original (ZIP)",
    partsHint: "El álbum es grande, así que se divide en {{parts}} partes; descarga cada una.",
    part: "Parte {{n}} ({{from}}–{{to}})",
    started: "Descarga iniciada — en álbumes grandes puede tardar unos minutos.",
    failed: "No se pudo cargar la información del álbum.",
  },

  // ─── Admin: Satış & Site (landing içeriği) ─────────
  siteAdmin: {
    title: "Ventas y Sitio",
    description: "Gestiona los precios y contenidos del sitio promocional (wedding.mertbal.com). Los cambios guardados aparecen en el sitio en 1–2 minutos.",
    openSite: "Abrir sitio",
    reload: "Recargar",
    tabs: {
      pricing: "Precios",
      leads: "Solicitudes",
      proof: "Prueba social",
      media: "Escaparate",
      retention: "Conservación",
      demo: "Demo de invitado",
      sales: "Venta online",
      legal: "Legal",
      ledger: "Registro",
    },
    save: "Guardar",
    saving: "Guardando…",
    saved: "Guardado — visible en el sitio en 1–2 minutos.",
    saveFailed: "No se pudo guardar: {{error}}",
    invalid: "Hay campos no válidos — corrige las filas marcadas.",
    loadFailed: "No se pudieron cargar los ajustes.",
    retry: "Reintentar",
    unsaved: "Cambios sin guardar",
    pricing: {
      showTitle: "Mostrar precios en el sitio",
      showDesc: "Desactivado, las tarjetas de paquetes no muestran precios, la compra online se cierra y el formulario no muestra estimación; el visitante pide presupuesto.",
      packagesTitle: "Precios de los paquetes",
      packagesHint: "El precio y los números (invitados/medios/almacenamiento) vienen de la definición del paquete — la tarjeta del sitio, la compra, el formulario y la venta manual usan los mismos números. Sin precios por rango de invitados.",
      editPackages: "Editar en Paquetes",
      packageGuests: "hasta {{n}} invitados",
      noteTitle: "Nota de precios",
      noteHint: "Se muestra bajo las tarjetas de paquetes. Si está vacío, se muestra el texto predeterminado en 4 idiomas; la nota escrita aquí no se traduce.",
    },
    leads: {
      unavailableTitle: "El registro de solicitudes aún no está activo",
      unavailableBody: "Cuando se aplique la actualización de la base de datos (migración 052), las solicitudes del formulario aparecerán aquí. Hasta entonces llegan solo por correo.",
      funnelTitle: "Formulario de presupuesto — últimos 30 días",
      funnelHint: "Contadores diarios anónimos; cada paso cuenta una vez por carga de página. Porcentajes sobre quienes vieron el formulario.",
      stepView: "Vio el formulario",
      stepStep1: "Empezó a rellenar",
      stepStep2: "Llegó al paso de contacto",
      stepSubmit: "Envió",
      pct: "{{pct}} %",
      filterAll: "Todas",
      planChosen: "Paquete {{plan}}",
      planCustom: "Más grande · presupuesto a medida",
      statusLabel: "Estado",
      status: {
        new: "Nueva",
        contacted: "Contactada",
        won: "Ganada",
        lost: "Perdida",
      },
      empty: "No hay solicitudes con este filtro.",
      emailNotSent: "Correo no enviado",
      noEstimate: "Sin estimación",
      note: "Nota",
      notePh: "Notas de llamada (solo admins)",
      saveNote: "Guardar nota",
      delete: "Eliminar",
      deleteConfirm: "¿Eliminar definitivamente la solicitud de {{name}}? (solicitud de supresión)",
      deleted: "Solicitud eliminada.",
      updated: "Actualizado.",
      failed: "La acción falló: {{error}}",
      loadMore: "Cargar más",
      loadFailed: "No se pudieron cargar las solicitudes.",
    },
    proof: {
      statsTitle: "Cifras de uso reales",
      statsDesc: "Se muestran en el sitio como «X álbumes de boda · Y fotos y vídeos compartidos». Las cifras vienen de la base de datos; una cifra por debajo de su umbral nunca se muestra.",
      show: "Mostrar cifras en el sitio",
      minWeddings: "Umbral de visualización — bodas",
      minMedia: "Umbral de visualización — fotos",
      current: "Ahora",
      currentWeddings: "{{n}} bodas (con al menos {{min}} fotos aprobadas)",
      currentMedia: "{{n}} fotos aprobadas",
      visible: "visible en el sitio",
      hidden: "bajo el umbral, oculta",
      off: "desactivado",
      unknown: "No se pudieron leer las cifras ahora.",
      testimonialsTitle: "Testimonios de parejas",
      testimonialsDesc: "Añade solo testimonios reales con permiso de publicación — una reseña inventada es publicidad ilícita. El texto se muestra en el idioma en que se escribió.",
      empty: "Aún no hay testimonios — la sección está oculta en el sitio.",
      add: "Añadir testimonio",
      couple: "Pareja",
      couplePh: "Ayşe & Can",
      when: "Cuándo",
      whenPh: "Junio 2026",
      city: "Ciudad",
      cityPh: "Esmirna",
      quote: "Testimonio",
      quotePh: "Cada foto que hicieron nuestros invitados estaba en el álbum a la mañana siguiente…",
      rating: "Puntuación",
      noRating: "Sin puntuación",
      showOnSite: "Mostrar en el sitio",
      moveUp: "Subir",
      moveDown: "Bajar",
      remove: "Quitar",
      limit: "Máximo {{max}} testimonios.",
    },
    media: {
      consent: "Sube solo fotos y vídeos que la pareja autorice publicar; el contenido con caras de invitados requiere su consentimiento.",
      photosTitle: "Fotos reales de bodas",
      photosHint: "Al subirlas sustituyen las imágenes de archivo del sitio y se usan en este orden en todos los huecos de foto. Horizontales, mínimo 1600 px; JPEG/PNG/WebP/AVIF, máximo 10 MB.",
      photosEmpty: "Aún no hay fotos — el sitio muestra imágenes de archivo.",
      addPhotos: "Añadir fotos",
      videoTitle: "Vídeo de Sahne",
      videoHint: "Se muestra bajo la sección Sahne con el título «En una boda real». Solo MP4 (H.264), máximo 95 MB; se recomiendan 30–60 s. Una portada evita descargar el vídeo al cargar la página.",
      video: "Vídeo",
      videoEmpty: "Sin vídeo — el bloque está oculto.",
      poster: "Imagen de portada",
      posterEmpty: "Sin portada — el navegador muestra el primer fotograma.",
      upload: "Subir",
      replace: "Reemplazar",
      uploadingN: "Subiendo {{n}}/{{total}}",
      processing: "Subido, guardando en el servidor…",
      uploaded: "{{count}} archivo(s) subido(s).",
      removeConfirm: "¿Eliminar definitivamente este archivo del sitio y del almacenamiento?",
      removed: "Eliminado.",
      err: {
        too_large: "Archivo demasiado grande (imágenes 10 MB, vídeo 95 MB).",
        mp4_only: "El vídeo debe ser MP4.",
        image_only: "El archivo no es una imagen JPEG/PNG/WebP/AVIF válida.",
        limit: "Máximo 12 fotos.",
        network: "Error de red — inténtalo de nuevo.",
        media_changed: "El escaparate cambió en otra pestaña: la lista se recargó, inténtalo de nuevo.",
        length_required: "No se pudo leer el tamaño del archivo; inténtalo de nuevo.",
      },
    },
    retention: {
      title: "Promesa de conservación del álbum",
      desc: "Se muestra en las preguntas frecuentes y en la nota de planes. El sistema nunca borra automáticamente las fotos aprobadas; es el período mínimo prometido.",
      show: "Mostrar la promesa en el sitio",
      months: "Período mínimo (meses)",
      hidden: "Promesa oculta — la pregunta no aparece en las preguntas frecuentes.",
      warn: "Acortar el período no cambia lo prometido a quienes compraron con esta promesa.",
    },
    demo: {
      title: "Demo de invitado (boda de ejemplo)",
      desc: "Los visitantes entran en /sample-wedding sin teléfono y prueban la app de invitado (subida, galería, Sahne). No es un ejemplo de invitación. Lo que suben pasa por moderación, nunca es público y se borra cada noche.",
      state: "Estado",
      live: "En vivo",
      none: "Sin instalar",
      seedMedia: "Fotos semilla",
      visitors: "Visitantes de hoy",
      pending: "Pendientes",
      setup: "Instalar demo",
      reset: "Restablecer",
      resetConfirm: "¿Borrar todo en la boda de demo y volver a instalarla? (visitantes, subidas, comentarios)",
      setupDone: "Demo lista — {{count}} fotos semilla.",
      clearVisitors: "Limpiar visitantes",
      clearConfirm: "¿Borrar los visitantes de hoy y sus subidas? Las fotos semilla se mantienen.",
      cleared: "{{count}} visitante(s) eliminado(s).",
      open: "Abrir demo de invitado",
      moderation: "Ir a moderación",
      seedHint: "Las fotos semilla se copian de las fotos reales del Escaparate; si está vacío se usan imágenes de archivo. La limpieza nocturna solo corre en producción.",
      slugTaken: "«{{slug}}» pertenece a una boda real — no se puede instalar la demo y no se borró nada.",
      ctaTitle: "Mostrar en la web",
      ctaDesc: "Publicada, aparece un pequeño enlace “Pruébalo como invitado” en el paso “Compartir” de “Cómo funciona”; los botones principales no cambian. No se puede publicar antes de instalar la demo.",
      onSite: "Publicada en la web",
      offSite: "No publicada",
      publish: "Publicar en la web",
      unpublish: "Retirar de la web",
      published: "Demo de invitado publicada en la web.",
      unpublished: "Demo de invitado retirada de la web.",
    },
    sales: {
      selfServeTitle: "Los organizadores pueden abrir su cuenta",
      selfServeOn: "Activado: el panel de organizador muestra una página «Crear cuenta» (/signup) — nombre + aceptación de condiciones; se abre una cuenta Free al verificar el código del correo. La pantalla de inicio de sesión nunca crea cuentas.",
      selfServeOff: "Desactivado (recomendado): solo los organizadores existentes inician sesión; tú abres las cuentas nuevas. Si se escribe un correo desconocido al iniciar sesión, no se crea cuenta y la dirección recibe un aviso para pedir presupuesto.",
      closeConfirm: "¿Cerrar el registro de organizadores? Las cuentas existentes no se ven afectadas.",
      ordersTitle: "Venta online (Comprar)",
      ordersLive: "Activa y publicada: “Comprar” aparece en los planes de pago; los pedidos llegan abajo.",
      ordersBlocked: "Activa pero NO publicada — aparecerá cuando se resuelva lo de abajo.",
      ordersOff: "Desactivada: los visitantes solo ven el formulario de presupuesto.",
      ordersOpenConfirm: "¿Activar la venta online? “Comprar” aparecerá en la web; el pago es por transferencia y confirmas los pedidos aquí. Se recomienda que un abogado revise los contratos.",
      ledgerRequired: "La venta en línea no puede abrirse antes de aplicar el registro (migración 057): hay que conservar la prueba del contrato y del precio.",
      needLegal: "Falta la identidad del vendedor (nombre, dirección, correo):",
      needPricing: "Los precios están ocultos en la web:",
      ordersHint: "Aún no hay pasarela de pago (iyzico/PayTR): responde al pedido con los datos de pago y márcalo “Pagado” cuando llegue el dinero — se abre la cuenta y el comprador recibe acceso + contratos.",
      selfServeMoved: "Que el organizador abra su propia cuenta es un ajuste de la plataforma; ahora está en:",
    },
    orders: {
      title: "Pedidos",
      desc: "Compras online. No se borran: se conservan 10 años como registros de facturación.",
      filter: {
        pending: "Pendiente",
        paid: "Pagado",
        cancelled: "Cancelado",
        all: "Todos",
      },
      unavailable: "La tabla de pedidos aún no existe: aparecerán aquí tras aplicar la migración 053 (hasta entonces la compra devuelve 503).",
      empty: "No hay pedidos con este estado.",
      more: "Cargar más",
      loadFailed: "No se pudieron cargar los pedidos: {{error}}",
      buyer: "Comprador",
      eventDate: "Evento",
      address: "Facturación",
      email: "Correo",
      phone: "Tel.",
      created: "Pedido: {{at}}",
      paidAt: "Pago: {{at}}",
      paymentNote: "Nota de pago",
      paymentNotePh: "Nota de pago (p. ej. transferencia 13.10, n.º de recibo)",
      adminNote: "Nota interna",
      adminNotePh: "Nota interna (el comprador no la ve)",
      markPaid: "Marcar como pagado",
      cancel: "Cancelar",
      saveNotes: "Guardar notas",
      cancelConfirm: "¿Cancelar {{number}}?",
      paidCreated: "Pagado: cuenta de organizador abierta.",
      paidNoEmail: "Pagado, pero no se pudo enviar el correo al comprador: vuelve a intentarlo con «Enviar correo».",
      deactivated: "Esta cuenta de organizador está desactivada: reactívala en Usuarios.",
      cancelled: "Pedido cancelado.",
      cancelPaidConfirm: "¿Cancelar {{number}} (reembolso)? El paquete se retira de la boda: sin otro paquete, la boda queda suspendida (sin nuevos invitados ni subidas). Los invitados y las fotos no se borran.",
      paidExisting: "Pagado: vinculado a la cuenta existente (plan de la cuenta sin cambios).",
      paidEmailSkipped: "No se envió correo al comprador (tu elección): entrega la copia del contrato por otra vía.",
      emailInfoTitle: "Correos de compra",
      emailInfo1: "Al hacer el pedido no se envía correo al comprador; se avisa al buzón del negocio: responde a ese correo con los datos de pago.",
      emailInfo2: "Al marcar «Pagado» (opcional), el comprador recibe el enlace de acceso, la boda a la que se aplicó el paquete y una copia de la información precontractual + contrato de venta a distancia. También puede enviarse luego con «Enviar correo».",
      emailInfo3: "Al cancelar no se envía correo; tú gestionas la comunicación del reembolso.",
      paidTitle: "Marcar como pagado",
      applyTo: "Boda a la que aplicar el paquete",
      applyNext: "Que elija el organizador (el paquete espera en su cuenta)",
      applyHint: "El paquete es para un solo evento; el plan de la cuenta no cambia. Los límites de la boda elegida suben al derecho de este pedido.",
      sendEmail: "Enviar al comprador el correo de acceso + contrato",
      noEmailWarn: "La copia del contrato de venta a distancia debe entregarse al comprador en soporte duradero: si no la envías, hazlo por otra vía.",
      confirmPaid: "Confirmar",
      close: "Cancelar",
      weddingsFailed: "No se pudieron cargar las bodas: {{error}}",
      entitlement: "Derecho: {{guests}} invitados · {{media}} medios · {{storage}}",
      appliedTo: "Boda: {{title}}",
      appliedNext: "Boda: esperando a que el organizador elija (paquete en su cuenta)",
      move: "Mover",
      apply: "Aplicar",
      moved: "Paquete aplicado a la boda.",
      emailSentAt: "Correo enviado ({{at}})",
      emailNotSent: "Correo no enviado",
      sendEmailNow: "Enviar correo",
      resendEmail: "Reenviar",
      emailSent: "Correo enviado al comprador.",
      conflict: "Este pedido se procesó en otra pestaña: lista actualizada.",
      migrationRequired: "«Pagado» requiere la migración 055 (faltan columnas de derecho).",
      weddingNotOwned: "La boda elegida no pertenece a este comprador.",
      manualNew: "Pedido manual",
      manualHint: "Venta por presupuesto/transferencia. El plan de la cuenta NO cambia — el pedido se convierte en un derecho para una sola boda (al marcarlo “Pagado”). Los pedidos pendientes sin pagar en 7 días se cancelan automáticamente.",
      legacyBadge: "Transición (plan de cuenta anterior)",
      manualPlan: "Paquete",
      manualAmount: "Importe (₺)",
      manualAmountEach: "Importe — por paquete (₺)",
      manualQuantity: "Cantidad (paquetes)",
      manualQuantityHint: "Se abrirán {{count}} pedidos separados: cada uno da derecho a una boda, con su propio número. El organizador asigna cada paquete a una boda.",
      pickOrganizer: "Organizador existente (opcional)",
      pickOrganizerPh: "Buscar por correo o nombre",
      pickNone: "Ningún organizador coincide — introduce los datos del comprador manualmente.",
      pickFailed: "La búsqueda falló, inténtalo de nuevo.",
      pickedLabel: "Organizador: {{name}} · {{email}}",
      pickChange: "Cambiar",
      pickWeddings: "{{count}} bodas",
      pickHint: "Al elegirlo se rellenan nombre, correo y teléfono de la cuenta; una vez pagado, el paquete aparece en Mis paquetes de esa cuenta.",
      manualCreate: "Crear pedido",
      manualCreated: "{{number}} creado — márcalo “Pagado” cuando llegue el pago.",
      manualCreatedMany: "{{count}} pedidos abiertos: {{numbers}} — marca cada uno “Pagado” cuando llegue el pago.",
      fix: "Corregir",
      saveFix: "Guardar corrección",
      corrected: "Datos del comprador corregidos.",
      foreignLabel: "Boda en otra cuenta (dirección)",
      foreignPh: "boda-ejemplo",
      foreignHint: "Si la boda se creó con otro correo, escribe su dirección (slug); el derecho va a esa boda y la cuenta del comprador no cambia.",
      guestsShort: "{{n}} invitados",
      archived: "archivada",
      overCap: "Esta boda ya tiene {{guests}} invitados; el pedido permite {{cap}}. Los sobrantes no se borran, pero se cierran los nuevos registros por QR.",
      impact: "Impacto — {{wedding}}: ahora {{guests}} invitados / {{media}} medios. Límite tras cancelar: {{guestsAfter}} invitados / {{mediaAfter}} medios.",
      impactOver: "⚠️ Tras cancelar, la boda queda POR ENCIMA de su límite: se detienen nuevos invitados y subidas.",
      weddingNotFound: "No hay ninguna boda en esta dirección.",
      notPending: "Los datos del comprador solo se corrigen en un pedido pendiente (y por separado de un cambio de estado).",
      contractCopy: "Copia del contrato",
      noContract: "Este pedido no tiene texto de contrato guardado (venta por presupuesto o pedido anterior al registro).",
      ledgerEvents: "{{count}} entradas en el registro.",
      listPrice: "(precio de lista {{price}})",
      refundReasonPrompt: "Motivo del reembolso (obligatorio, se anota en el registro):",
      moveReason: "Motivo del traslado (obligatorio)",
      moveReasonPh: "p. ej. estaba vinculado a la boda equivocada",
      paymentRef: "Referencia de pago (obligatoria)",
      paymentRefHint: "N.º de recibo / concepto de la transferencia — prueba del cobro, se anota en el registro.",
      packageOption: "{{label}} · {{guests}} invitados · {{price}}",
      noPackages: "No hay paquetes vendibles — define uno en Paquetes primero.",
      noListPrice: "Este paquete no tiene precio de lista (con presupuesto) — el motivo es obligatorio.",
      listPriceNote: "Precio de lista {{price}} — el importe y todos los números vienen de la definición del paquete.",
      discountNote: "Precio de lista {{price}} · descuento {{discount}} — el motivo es obligatorio.",
      reasonRequired: "Motivo (obligatorio — descuento / presupuesto)",
      errors: {
        paymentRef: "Se necesita una referencia de pago (recibo / concepto) para marcar como pagado.",
        reason: "Se necesita un motivo (al menos 3 caracteres).",
        packageInUse: "Este paquete ya se usó (hay invitados/medios o el evento pasó) — no puede liberarse; reembolsa o trasládalo a otra boda.",
        targetHasPackage: "La boda elegida ya tiene un paquete pagado — un paquete por boda.",
        packageNotFound: "Definición de paquete no encontrada o inactiva.",
        packageNotSellable: "El paquete predeterminado (Free) no se vende.",
        invalidTransition: "Esta acción no es posible en el estado actual del pedido.",
      },
    },
    ledger: {
      title: "Registro de ventas",
      desc: "Historial de precios y condiciones, límites de paquetes, pedidos y paquetes adicionales. Solo se añade: no se puede modificar ni borrar y se conserva al menos 10 años. Sirve para mostrar qué precio regía en qué fecha y el texto exacto del contrato que aceptó el comprador.",
      verify: "Verificar integridad",
      verifyOk: "Registro íntegro — {{count}} entradas verificadas de principio a fin.",
      verifyBroken: "Atención: la entrada n.º {{seq}} fue alterada o la cadena está rota. Compárala con una copia de seguridad.",
      unavailable: "El registro aún no existe — empieza a registrar al aplicar la migración 057 (la venta en línea no puede abrirse antes).",
      empty: "No hay entradas con este filtro.",
      loadFailed: "No se pudo leer el registro: {{error}}",
      more: "Cargar más",
      actor: "Por",
      contract: "Texto aceptado por el comprador (resumen SHA-256: {{hash}})",
      filter: {
        all: "Todo",
        settings: "Precios y condiciones",
        plan: "Límites de paquetes",
        order: "Pedidos",
        addon: "Paquetes adicionales",
      },
      accountPlanSubject: "Cuenta {{id}}: {{before}} → {{after}}",
      packageSubject: "{{kind}} {{label}} · {{id}}",
      packageFree: "Paquete Free",
      packageLegacy: "Paquete de transición",
      events: {
        created: "creado",
        paid: "pagado",
        cancelled: "cancelado",
        moved: "movido",
        corrected: "corregido",
        applied: "asignado a la boda",
        updated: "cambiado",
        deleted: "eliminado",
        baseline: "valor previo al registro",
        accountPlan: "Plan de cuenta asignado",
        granted: "paquete otorgado",
        assigned: "asignado a la boda",
        replaced: "sustituido por un paquete de pago",
        revoked: "retirado",
        noted: "nota cambiada",
        propagated: "definición aplicada a los vendidos",
      },
    },
    addons: {
      save: "Guardar paquetes",
      title: "Paquetes de invitados extra (registros QR)",
      desc: "Cuando se llena el límite de invitados, el organizador abre un paquete para personas extra que se registran por QR. El paquete se activa AL INSTANTE y queda como «pago pendiente»; cóbralo en Venta online → Paquetes extra. Los precios siempre se leen de aquí (servidor).",
      enabled: "Los organizadores pueden abrir paquetes",
      seats: "Invitados",
      price: "Precio (₺)",
      seatsFor: "Invitados del paquete {{n}}",
      priceFor: "Precio del paquete {{n}}",
      perGuest: "≈ {{price}} por invitado",
      invalid: "Invitados 1–1000 y precio 0–100.000 en números enteros; sin cantidades repetidas.",
      panelTitle: "Paquetes extra",
      panelDesc: "Paquetes de registro QR abiertos por organizadores. Activos al abrirse; «Pagado» al recibir la transferencia, «Cancelar» si no se paga (las plazas extra se cierran al instante).",
      filter: { pending: "Pago pendiente", paid: "Pagado", cancelled: "Cancelado", all: "Todos" },
      markPaid: "Pagado",
      cancel: "Cancelar",
      paidConfirm: "¿Marcar como pagado el paquete +{{seats}} de /{{slug}}?",
      paidRefPrompt: "¿Marcar como pagado el paquete +{{seats}} de /{{slug}} ({{amount}})? Referencia de pago (n.º de recibo / concepto, obligatoria):",
      paymentRefRequired: "Se necesita una referencia de pago (recibo / concepto).",
      cancelConfirm: "¿Cancelar el paquete +{{seats}} de /{{slug}}? Las plazas extra se cierran al instante; los invitados registrados no se borran.",
      markedPaid: "Paquete marcado como pagado.",
      cancelled: "Paquete cancelado.",
      empty: "No hay paquetes en este estado.",
      unavailable: "La tabla de paquetes aún no existe: aparecerá aquí tras aplicar la migración 056.",
      loadFailed: "No se pudieron cargar los paquetes: {{error}}",
    },
    legal: {
      title: "Identidad legal",
      desc: "El responsable del tratamiento (aviso KVKK) y el proveedor (condiciones de uso) salen de estos campos. Nombre/razón social, dirección y correo son obligatorios antes de abrir la venta de pago (pedidos).",
      publicWarn: "Cada campo que rellenes se publica PÚBLICAMENTE en /privacy y /terms. Deja vacío lo que no deba publicarse — un campo vacío no se muestra.",
      complete: "Identidad completa — se pueden abrir las páginas de contrato y venta.",
      incomplete: "Incompleto: hasta rellenar nombre/razón social, dirección y correo, las páginas solo muestran el correo de contacto y la venta de pago sigue cerrada.",
      name: "Nombre completo / razón social",
      titleField: "Título / profesión (opcional)",
      address: "Dirección",
      phone: "Teléfono",
      email: "Correo (contact@mertbal.com si está vacío)",
      taxOffice: "Oficina tributaria",
      taxId: "N.º fiscal / de identidad",
      mersis: "N.º MERSIS",
      kep: "Correo certificado (KEP)",
      openKvkk: "Abrir página de privacidad",
      openTerms: "Abrir página de condiciones",
      clearConfirm: "¿Vaciar y guardar todos los campos de identidad legal? Las páginas solo mostrarán el correo de contacto.",
      clear: "Vaciar todo",
    },
  },

  plansAdmin: {
    siteNote: "La definición del paquete es la FUENTE ÚNICA: la tarjeta del sitio, la compra online, la venta manual y «Asignar paquete» toman de aquí los números (invitados/medios/almacenamiento/SMS) y el PRECIO. El sitio solo muestra Free · Pro · Max; los nombres son fijos. Los demás paquetes son privados (corporativos): ocultos en el sitio, se venden con presupuesto / «Asignar». Un paquete vendido es un contrato: cambiar la definición solo afecta a las NUEVAS ventas; los vendidos conservan los números con los que se compraron.",
    onSite: "En el sitio",
    onSiteHint: "Se muestra en el sitio comercial — no se puede eliminar, los límites son editables",
    private: "Privado",
    privateHint: "Plan privado — no aparece en el sitio comercial",
    reactivate: "Reactivar",
    created: "Plan creado.",
    updated: "Plan actualizado.",
    deleted: "Plan desactivado.",
    reactivated: "Plan reactivado.",
    failed: "La acción falló: {{error}}",
    sitePlanLocked: "Este plan está en el sitio comercial — no se puede eliminar.",
    subtitle: "Definiciones de paquetes: números y precio",
    price: "Precio (₺)",
    priceHint: "Déjalo vacío para vender solo con presupuesto (paquete privado/corporativo).",
    priceQuote: "Con presupuesto",
    priceDefault: "El paquete predeterminado (Free) siempre cuesta 0 ₺.",
    sold: "paquetes vendidos",
    accountUsers: "{{n}} cuentas con este plan de cuenta antiguo",
    soldNote: "Este paquete se vendió {{n}} veces. Los cambios solo se aplican a NUEVAS ventas; los vendidos conservan los números con los que se compraron (contrato). Si un cliente necesita más, la mejora es una venta aparte.",
    updatedNewSalesOnly: "Plan actualizado · se aplica a nuevas ventas; {{n}} paquetes vendidos conservan sus números.",
    errors: {
      defaultLocked: "El paquete predeterminado (Free) no puede cambiarse en el modelo de paquetes.",
      defaultPrice: "El paquete predeterminado es gratuito (0 ₺).",
      priceZero: "Un paquete de pago no puede costar 0 — déjalo vacío (con presupuesto) o pon un precio.",
      migrationRequired: "Se necesita la migración 059 para los precios.",
      invalid: "Valor no válido.",
    },
  },
  // ─── Admin: kullanıcı paketleri + Paket ver (2026-10-16) ─────────
  adminPackages: {
    title: "Paquetes",
    modeNote: "Modelo por paquetes: el plan de la cuenta no fija límites; los de cada boda vienen de su paquete. Da a los clientes empresariales un paquete con límites personalizados.",
    grant: "Otorgar paquete",
    guests: "{{n}} invitados",
    grantTitle: "Otorgar paquete",
    grantHint: "1 pedido = 1 paquete: se crea un pedido manual pagado. TODOS los números del paquete vienen de su definición (Paquetes). El importe puede ser 0 o con descuento; si es mayor que 0 se necesita una referencia de pago. El motivo se guarda en la nota interna y en el registro. Si eliges una boda, el paquete se le asigna (termina el paquete Free / de transición); si no, el usuario lo usa desde Mis paquetes.",
    plan: "Paquete",
    amount: "Importe (₺)",
    paymentNote: "Referencia de pago (obligatoria)",
    duplicateConfirm: "Ya se otorgó el mismo paquete a este usuario en los últimos 10 minutos. ¿Otorgar un segundo? (Si es una segunda pestaña / reintento, pulsa Cancelar.)",
    duplicateSkipped: "No se otorgó un segundo paquete — sigue vigente el de los últimos 10 minutos.",
    revoke: "Retirar",
    revokePrompt: "¿Retirar el paquete «{{label}}» ({{wedding}})? Sin otro paquete, la boda queda suspendida (sin nuevos invitados/subidas, no se borra nada). Motivo (obligatorio):",
    revoked: "Paquete {{label}} retirado.",
    wedding: "Boda",
    weddingNone: "No asignar — dejarlo disponible",
    weddingOption: "{{title}} — ahora: {{pkg}}",
    reason: "Motivo",
    reasonPh: "p. ej. venta telefónica, compensación, acuerdo empresarial",
    submit: "Otorgar paquete",
    granted: "Paquete otorgado: {{number}}",
    grantedTo: "Paquete otorgado: {{number}} → {{title}}",
    packagesMode: "La cuenta usa el modelo por paquetes — el plan de la cuenta no se puede cambiar; usa «Otorgar paquete».",
    errors: {
      packagesUnavailable: "No se pueden otorgar paquetes antes de aplicar la migración 058.",
      weddingNotFound: "La boda no pertenece a este usuario.",
      ordersUnavailable: "Falta la tabla de pedidos (migración 053/055).",
      generic: "No se pudo otorgar el paquete: {{error}}",
      paymentRef: "Se necesita una referencia de pago (recibo / concepto) si el importe es mayor que 0.",
      targetHasPackage: "Esta boda ya tiene un paquete pagado — un paquete por boda.",
      packageNotFound: "Definición de paquete no encontrada o inactiva.",
      packageNotSellable: "El paquete predeterminado (Free) no se puede otorgar — la cuenta ya lo tiene.",
      reason: "Se necesita un motivo (al menos 3 caracteres).",
      notActive: "El paquete ya terminó o fue retirado.",
      notFound: "El paquete no pertenece a este usuario.",
    },
  },

  // ─── Paketlerim (paket modeli, 2026-10-16) ─────────
  packages: {
    title: "Mis paquetes",
    subtitle: "Cada boda está vinculada a un paquete. Tu cuenta tiene un paquete Free; cada pedido pagado es un paquete nuevo.",
    buy: "Comprar un paquete",
    loadFailed: "No se pudieron cargar los paquetes.",
    tileAvailable: "Disponibles",
    tileInUse: "En uso",
    tilePending: "Pendientes de pago",
    tabPackages: "Paquetes",
    tabOrders: "Pedidos",
    available: "Disponibles",
    inUse: "En uso",
    pending: "Pendientes de pago",
    endedTitle: "Finalizados",
    noneAvailable: "No tienes paquetes disponibles. Compra uno para una nueva boda.",
    limits: "{{guests}} invitados · {{media}} fotos/vídeos · {{storage}}",
    freeName: "Free",
    legacyName: "{{plan}} (transición)",
    freeHint: "Una vez por cuenta. Se consume cuando la boda pasa a un paquete de pago.",
    paidHint: "El servicio comienza cuando se asigna a una boda.",
    pendingHint: "Pedido: {{date}}. Las instrucciones de transferencia están en tu correo — indica el número de pedido como concepto. El paquete estará disponible cuando se confirme el pago.",
    ended: {
      replaced: "Sustituido por un paquete de pago",
      revoked: "Retirado",
      cancelled: "Cancelado / reembolsado",
    },
    openWedding: "Abrir una boda con este paquete",
    orderUnassigned: "Aún no asignado a una boda",
    orderPendingShort: "Pago pendiente",
    addonsTitle: "Paquetes de invitados extra (QR)",
    addonSeats: "+{{seats}} invitados",
  },

  // ─── Límite de invitados + registro QR extra (tarjeta común) ───────────
  guestCapacity: {
    title: "Límite de invitados",
    breakdown: "Límite del paquete {{limit}} · extra {{extra}} (solo QR)",
    full: "Límite alcanzado: no se aceptan nuevos registros por QR. A los invitados se les pide avisar a los novios. Abre un paquete extra para ampliarlo.",
    almost: "Casi lleno. Al llenarse, no se aceptan nuevos registros por QR.",
    qrExtra: "Registros QR extra",
    off: "Desactivado",
    on: "Activado · +{{seats}}",
    packButton: "+{{seats}} invitados · {{price}}",
    statusPending: "pago pendiente",
    statusPaid: "pagado",
    due: "A pagar: {{amount}} (transferencia — datos por correo)",
    withdraw: "Retirar",
    cancel: "Cancelar",
    withdrawConfirm: "¿Retirar el paquete +{{seats}}? Las plazas extra se cierran; sin cargo.",
    cancelConfirmAdmin: "¿Cancelar el paquete +{{seats}}? Las plazas extra se cierran al instante (si se pagó, el reembolso es tuyo).",
    withdrawn: "Paquete +{{seats}} cerrado.",
    opened: "+{{seats}} invitados extra abiertos.",
    confirmTitle: "+{{seats}} invitados extra",
    confirmLimit: "El límite de registro QR pasa de {{from}} a {{to}}.",
    confirmQrOnly: "Las plazas extra son solo para registros por QR; añadir invitados a mano sigue dentro del límite del paquete.",
    confirmBilling: "El paquete se abre AL INSTANTE; se crea un pedido «pago pendiente» de {{price}}, pagadero por transferencia.",
    confirmUnpaid: "Si no se paga en {{days}} días, el paquete se cancela automáticamente y se detienen los registros extra (los invitados registrados se mantienen). Solo puede haber un paquete sin pagar a la vez.",
    confirmWithdraw: "Puedes retirar el paquete gratis mientras nadie se haya registrado por QR desde que se abrió.",
    comp: "Cortesía (gratis)",
    pendingExists: "Hay un paquete extra sin pagar — no se puede abrir otro hasta pagarlo (o retirarlo).",
    compReason: "Motivo de la cortesía (obligatorio)",
    compReasonPh: "p. ej. compensación, acuerdo corporativo",
    accept: "He leído y acepto el precio y las condiciones.",
    confirmButton: "Abrir +{{seats}} invitados",
    close: "Cancelar",
    loadFailed: "No se pudo cargar el límite de invitados.",
    retry: "Reintentar",
    migrationHint: "Los paquetes extra requieren la migración 056 (la regla de límite ya se aplica).",
    errors: {
      unavailable: "Ahora mismo no se pueden abrir paquetes extra.",
      disabled: "Los paquetes de invitados extra están desactivados.",
      unknownPack: "Este paquete ya no se ofrece: recarga la página.",
      duplicate: "Este paquete se acaba de abrir: recarga la página.",
      inUse: "Las plazas de este paquete están en uso; no se puede retirar.",
      paid: "Un paquete pagado no se puede retirar: contacta con soporte.",
      generic: "La acción falló: {{error}}",
      pendingExists: "Hay un paquete extra sin pagar — págalo o retíralo primero.",
      suspended: "La boda no tiene paquete (suspendida) — no se pueden abrir paquetes extra.",
      reason: "Se necesita un motivo para un paquete de cortesía.",
    },
    pkg: {
      title: "Paquete",
      order: "pedido {{number}}",
      account: "plan de la cuenta",
      trial: "prueba gratuita — sin paquete",
      media: "Fotos/vídeos",
      storage: "Almacenamiento",
      sms: "SMS",
      free: "paquete Free",
      legacy: "paquete de transición (plan de cuenta antiguo)",
      suspended: "sin paquete — boda suspendida",
    },
  },

  planChange: {
    accountPlanWarning: "El plan de la cuenta se aplica indefinidamente a TODAS las bodas sin paquete asignado (toda la cuenta). Pro y Max se venden por boda: no se pueden asignar aquí — abre un “Pedido manual” en Ventas y Sitio → Venta online (Cantidad para varios paquetes). El plan de la cuenta es solo para volver a Free y para acuerdos personalizados (empresa/suscripción). Para una cuenta Pro/Max antigua, usa la herramienta “Plan de la cuenta → paquetes por boda” de abajo.",
    title: "Cambiar plan de la cuenta",
    rowLabel: "Plan de la cuenta",
    perWeddingOption: "Se vende por boda — con “Pedido manual”",
    perWeddingPlan: "Pro/Max no se pueden asignar como plan de la cuenta: se venden por boda. Usa Ventas y Sitio → Venta online → “Pedido manual”.",
    conversion: {
      title: "Plan de la cuenta → paquetes por boda",
      desc: "A esta cuenta se le asignó el plan {{plan}} antes del modelo «un paquete = una boda»: todas las bodas sin paquete usan los límites de {{plan}} y no tienen número de pedido. Al convertir se abre un pedido de transición de 0 ₺ para cada boda seleccionada (número que empieza por G, registrado en el libro); la boda no pierde ningún límite. La cuenta pasa al plan {{to}} (prueba gratuita).",
      notConvertible: "El plan de esta cuenta ({{plan}}) es un plan personalizado: se mantiene a nivel de cuenta a propósito (empresa). No se convierte.",
      guests: "{{count}} invitados",
      hasOrder: "Tiene paquete: {{number}}",
      notOwner: "Pertenece a otra cuenta",
      archived: "archivada",
      unselectedWarn: "{{count}} boda(s) no seleccionada(s) pasan a los límites de la prueba gratuita ({{guests}} invitados): no se borra ningún dato, pero se detienen los nuevos registros y subidas por encima del límite. No selecciones las bodas de prueba.",
      button: "Convertir a paquetes por boda",
      confirm: "Se abrirá un paquete de transición {{plan}} para {{count}} boda(s) y la cuenta pasará al plan {{to}}. No se puede deshacer (si hace falta, los pedidos se cancelan uno a uno). ¿Continuar?",
      done: "Convertido — {{count}} pedido(s) de transición: {{numbers}}",
      doneNone: "Convertido — la cuenta pasó a {{to}}, no se abrió ningún paquete",
      failed: "No se pudo convertir: {{error}}",
      planChanged: "El plan de la cuenta cambió mientras tanto: recarga la página e inténtalo de nuevo",
      loadFailed: "No se pudo cargar la información de conversión: {{error}}",
    },
  },

  privacyAdmin: {
    title: "Solicitudes de privacidad (KVKK)",
    description: "Cuando alguien pide borrar sus datos: busca sus registros de invitado en todas las bodas por número de teléfono, revísalos y bórralos/anonimízalos de una vez. Las búsquedas y borrados quedan en el registro de auditoría (con el número enmascarado).",
    phoneLabel: "Número de teléfono",
    phoneHint: "Escríbelo como 0555 123 45 67 o +34….",
    willSearch: "Se buscará: {{phone}}",
    invalidPhone: "Introduce un número válido.",
    search: "Buscar",
    lookupFailed: "No se pudo buscar: {{error}}",
    resultTitle: "Resultados para {{phone}}",
    resultMeta: "Códigos de verificación: {{authCodes}} · Solicitudes de presupuesto: {{leads}} · Entradas de auditoría: {{audit}}",
    ordersKept: "Hay {{count}} pedidos de este número: se conservan 10 años como registros de facturación por ley fiscal; esta herramienta no los borra.",
    organizerNote: "También hay una cuenta de organizador con este número. Esta herramienta no borra cuentas de organizador; ciérrala por separado si hace falta:",
    nothing: "No hay registros para este número.",
    noGuests: "No hay registros de invitado; solo se limpiarán códigos, solicitudes y entradas de auditoría.",
    noName: "(sin nombre)",
    guestActive: "Invitado activo",
    guestRemoved: "Retirado de la boda",
    counts: "{{media}} archivos · {{comments}} comentarios · {{likes}} me gusta · {{rsvp}} RSVP · {{sms}} SMS",
    eraseExplain: "Se borran: fotos/vídeos del invitado (con sus archivos), comentarios y me gusta, RSVP, códigos de verificación, solicitudes de presupuesto y sesiones abiertas. El registro del invitado se anonimiza (sin nombre ni teléfono); el número se enmascara en los envíos SMS y la auditoría. No se puede deshacer.",
    erase: "Borrar y anonimizar",
    eraseConfirm: "Se borrarán definitivamente {{count}} registros de invitado de {{phone}} y todos sus datos. No se puede deshacer. ¿Continuar?",
    erased: "Borrado completado",
    eraseFailed: "No se pudo borrar: {{error}}",
    erasedSummary: "{{phone}}: {{guests}} registros anonimizados, {{media}} archivos borrados, número enmascarado en {{audit}} entradas de auditoría.",
  },

  landing: {
    meta: {
      title: "{{brand}} — Lo que te perdiste, en un solo álbum",
      description: "Tus invitados escanean un código QR; cada foto y vídeo llega a un solo álbum en calidad original, y los que apruebas se proyectan en la pantalla grande del salón. Sin apps que descargar.",
    },
    nav: {
      home: "Inicio de {{brand}}",
      how: "Cómo funciona",
      sahne: "Sahne",
      themes: "Invitaciones",
      plans: "Planes",
      faq: "Preguntas",
      contact: "Presupuesto",
      login: "Iniciar sesión",
      cta: "Pedir presupuesto",
      menu: "Abrir menú",
      close: "Cerrar menú",
      skip: "Ir al contenido",
    },
    hero: {
      eyebrow: "El álbum de boda con QR",
      titleA: "Lo que te perdiste,",
      titleB: "en un solo álbum.",
      lead: "Tus invitados escanean un código QR y sus fotos y vídeos llegan a tu álbum en calidad original. Los que apruebas se proyectan toda la noche en la pantalla grande.",
      ctaPrimary: "Pedir presupuesto",
      ctaHow: "Ver cómo funciona",
      live: "En directo",
      live1: "Nueva foto de la mesa 7",
      live2: "Elif compartió un vídeo",
      live3: "14 corazones para el primer baile",
      promise1: "Sin apps: basta con escanear el QR",
      promise2: "Calidad original, sin compresión",
      promise3: "Lo que apruebas sale en pantalla en segundos",
    },
    marquee: {
      m1: "Ceremonia",
      m2: "Noche de henna",
      m3: "Boda",
      m4: "Compromiso",
      m5: "After party",
      m6: "Pedida",
    },
    manifesto: {
      eyebrow: "¿Te suena?",
      body: "La mañana después de la boda, las mejores fotos de la noche están repartidas en cuarenta y siete móviles, doce grupos de WhatsApp y un “luego te las paso” que nunca llega.",
      resolve: "Nosotros las reunimos en un solo álbum, con la calidad del primer día.",
      chip1: "«¿Me pasas las fotos?»",
      chip2: "WhatsApp · comprimida",
      chip3: "Este enlace ha caducado",
      chip4: "“Luego te las paso” — el primo Emre",
      chip5: "Almacenamiento lleno",
      chip6: "Sin acceso a la carpeta de Drive",
    },
    how: {
      eyebrow: "Cómo funciona",
      title: "Tres pasos.",
      titleAccent: "Cero apps.",
      lead: "Para tus invitados, tan familiar como la cámara del móvil. Para ti, un solo álbum.",
      step1Title: "Escanea",
      step1Body: "Tus invitados escanean el código QR de la tarjeta de mesa, la invitación o el cartel de bienvenida con la cámara del móvil. Sin descargas ni contraseñas.",
      step2Title: "Comparte",
      step2Body: "Entran con un código de un solo uso que reciben en el móvil y suben fotos y vídeos. Sin compresión: tal cual los grabaron.",
      step3Title: "Disfruta",
      step3Body: "Cada foto que apruebas llega a la pantalla grande del salón (Sahne), con los corazones que envían los invitados desde sus móviles.",
      cardShare: "Comparte tus recuerdos con nosotros",
      cardTable: "Mesa 7",
      cardScan: "Escanea con tu cámara",
      phoneTitle: "Compartir un recuerdo",
      phoneVerified: "Tu número está verificado",
      phoneUploading: "Subiendo 4 archivos",
      phoneOriginal: "Calidad original",
      phoneSend: "Compartir",
      tryAsGuest: "Pruébalo como invitado",
      tryAsGuestNote: "Boda de ejemplo — sin número de teléfono; lo que se sube se borra cada noche.",
    },
    sahne: {
      eyebrow: "Sahne",
      title: "Las fotos de la noche,",
      titleAccent: "al instante",
      titleEnd: "en pantalla grande.",
      lead: "El invitado dispara, tú apruebas y la foto aparece en la pantalla gigante en segundos. Los corazones enviados desde los móviles flotan en la pantalla y los comentarios se convierten en burbujas.",
      live: "En directo",
      watching: "{{count}} viendo",
      sharedBy: "Compartido por {{name}}",
      comment1: "Este baile es legendario 💃",
      comment2: "Mirad la sonrisa de la novia ❤️",
      comment3: "¡Yo también me uno al halay!",
      join: "Únete a la celebración",
      joinHint: "Comparte fotos y envía corazones",
      f1Title: "En pantalla en segundos",
      f1Body: "En cuanto apruebas, la foto aparece a la vez en todas las pantallas del salón.",
      f2Title: "Corazones y comentarios desde el móvil",
      f2Body: "Los invitados reaccionan con un toque; una esquina de la pantalla muestra quién está mirando.",
      f3Title: "Tú controlas la pantalla",
      f3Body: "Desde tu móvil elige la siguiente foto, destácala, pausa u oculta.",
      rejiLabel: "Reji",
      rejiNext: "A continuación",
      rejiSpotlight: "Destacar",
      videoCaption: "En una boda real: Sahne durante toda la noche",
    },
    control: {
      eyebrow: "Control",
      title: "El editor de la noche",
      titleAccent: "eres tú.",
      lead: "Tú decides qué entra en el álbum y qué se proyecta. El panel se encarga del resto.",
      modTitle: "Aprobación antes de publicar",
      modBody: "Cada foto pasa primero por la cola de moderación. Aprueba, rechaza y, si hace falta, bloquea a quien la envió con un toque.",
      modPending: "{{count}} fotos esperando aprobación",
      modApprove: "Aprobar",
      modReject: "Rechazar",
      otpTitle: "Solo invitados reales",
      otpBody: "El acceso es con un código de un solo uso enviado al móvil. Tu álbum no es un enlace público.",
      otpLabel: "Código de verificación",
      rsvpTitle: "RSVP al instante",
      rsvpBody: "Quién viene, quién no y quién aún lo está pensando, en directo en tu panel.",
      rsvpYes: "Asisten",
      rsvpNo: "No asisten",
      rsvpPending: "Sin respuesta",
      smsTitle: "Invitaciones y recordatorios por SMS",
      smsBody: "Una invitación para todos y un recordatorio amable para quien no ha respondido. Elige el público y prográmalo.",
      smsPreview: "Estimada Ayşe Yılmaz, nos encantaría contar contigo en la boda de Deniz & Arda el 23 de agosto. Toca el enlace para confirmar tu asistencia.",
      smsSegment: "Sin RSVP",
      qrTitle: "Analítica del QR",
      qrBody: "¿De verdad se abre tu invitación? Mira cuántas personas la escanearon cada día.",
      qrWeek: "Últimos 7 días",
      eventsTitle: "Henna + Boda",
      eventsBody: "Dos eventos, un solo álbum. Cuando pasa el primero, la cuenta atrás y el lugar cambian solos al siguiente.",
      eventsKina: "Henna",
      eventsDugun: "Boda",
      eventsDone: "Celebrado",
      langTitle: "Cuatro idiomas",
      langBody: "Turco, inglés, francés y español: cada invitado elige el suyo.",
      qualityTitle: "Calidad original",
      qualityBody: "Sin compresión. Lo que hay en el móvil del invitado es lo que llega al álbum.",
      qualityPhoto: "por foto",
      qualityVideo: "por vídeo",
      notifyTitle: "Avisos por Telegram",
      notifyBody: "Recibe un aviso en cuanto una foto nueva espera tu aprobación.",
      notifySample: "3 fotos nuevas esperando aprobación",
    },
    themes: {
      eyebrow: "Invitación",
      title: "Tu invitación no es un enlace.",
      titleAccent: "Es una escena de apertura.",
      lead: "La primera pantalla que ve el invitado al escanear: temas cinematográficos que se despliegan al desplazarse. Previsualízalos ahora mismo.",
      count: "{{count}} temas",
      preview: "Vista previa",
      drag: "Arrastra para explorar",
      premium: "Premium",
      classic: "Clásico",
    },
    compare: {
      eyebrow: "Comparativa",
      title: "Por qué un grupo de WhatsApp",
      titleAccent: "no basta.",
      feature: "Función",
      colWhatsapp: "Grupo de WhatsApp",
      colDrive: "Carpeta de Drive",
      colQrAlbum: "Álbum QR típico",
      rowQuality: "Calidad original",
      rowSingle: "Todo en un solo lugar",
      rowLive: "En la pantalla gigante toda la noche",
      rowModeration: "Aprobación antes de publicar",
      rowVerified: "Solo invitados verificados",
      rowNoApp: "Nada extra que instalar",
      rowVideo: "Vídeo",
      yes: "Sí",
      no: "No",
      partial: "En parte",
    },
    proof: {
      eyebrow: "Las parejas cuentan",
      title: "Bodas reales,",
      titleAccent: "momentos reales.",
      statWeddings: "álbumes de boda",
      statMedia: "fotos y vídeos compartidos",
      rating: "{{n}} de 5",
    },
    checkout: {
      eyebrow: "Compra online",
      title: "Compra tu paquete",
      lead: "Elige tu paquete, introduce tus datos y confirma el pedido. El pago es por transferencia; tu cuenta se abre al recibirlo.",
      loading: "Cargando",
      closedTitle: "La venta online está cerrada ahora mismo",
      closedBody: "Puedes pedir un paquete con el formulario de presupuesto en dos minutos; respondemos el mismo día.",
      closedCta: "Ir al formulario de presupuesto",
      packageLabel: "Paquete",
      packageGuests: "hasta {{n}} invitados",
      packageQuote: "Con presupuesto",
      name: "Nombre completo",
      email: "Correo",
      phone: "Teléfono",
      eventDate: "Fecha del evento",
      address: "Dirección de facturación",
      addressHint: "Dirección completa para el contrato y la factura.",
      taxId: "N.º de identidad / fiscal",
      taxIdHint: "Para la factura; número fiscal si compras para una empresa.",
      optional: "opcional",
      docsTitle: "Información precontractual y contrato de venta a distancia",
      docsLangNote: "Los textos del contrato están en turco (ley turca).",
      accept: "He leído y acepto el formulario de información precontractual y el contrato de venta a distancia.",
      summaryTitle: "Resumen del pedido",
      summaryOnce: "Pago único · impuestos incluidos",
      summaryPick: "Elige tu paquete.",
      step1: "1 — Confirmas el pedido.",
      step2: "2 — Te enviamos los datos de pago en 1 día hábil.",
      step3: "3 — Al recibir el pago se abre tu cuenta y te llegan los datos de acceso por correo.",
      submit: "Confirmar pedido",
      sending: "Enviando…",
      seller: "Vendedor: {{name}}",
      errField: "Revisa este campo.",
      errAccept: "Acepta los textos del contrato para continuar.",
      errInvalid: "Faltan campos o son incorrectos.",
      errPackage: "Elige un paquete disponible online.",
      errVerify: "Esperando la verificación de seguridad — inténtalo en unos segundos.",
      errVerifyFailed: "No se pudo cargar la verificación de seguridad. Recarga la página o usa el formulario de presupuesto.",
      errClosed: "Este paquete no se vende online ahora mismo — usa el formulario de presupuesto.",
      errUnavailable: "Ahora no se pueden recibir pedidos. Usa el formulario de presupuesto.",
      errTermsChanged: "El precio o las condiciones del contrato se actualizaron mientras leía. Revise el texto actual y vuelva a confirmar.",
      errFailed: "No se pudo enviar el pedido. Inténtalo de nuevo.",
      toastSent: "Pedido recibido",
      successTitle: "Pedido recibido",
      successBody: "Tu número de pedido es {{number}}. Enviaremos los datos de pago a {{email}} en 1 día hábil.",
      successNext: "Cuando llegue tu pago se abrirá tu cuenta de organizador; los datos de acceso y una copia de los contratos llegarán por correo.",
      backHome: "Volver al inicio",
    },
    plans: {
      eyebrow: "Planes",
      title: "Tres paquetes,",
      titleAccent: "según tus invitados.",
      lead: "Los paquetes se diferencian por invitados, fotos/vídeos y almacenamiento. Te ayudamos a elegir el adecuado.",
      freeTagline: "Para probar y celebraciones pequeñas",
      proTagline: "Para la mayoría de las bodas",
      maxTagline: "Para bodas grandes y organizadores",
      limitGuests: "Invitados",
      guestsUpTo: "hasta {{n}}",
      limitMedia: "Fotos y vídeos / boda",
      limitStorage: "Almacenamiento",
      recommended: "Recomendado",
      ctaFree: "Solicitar el paquete gratuito",
      ctaPaid: "Pedir presupuesto",
      ctaBuy: "Comprar",
      note: "El precio depende de tus eventos y del número de invitados: solo rellena el formulario.",
      priceOnce: "pago único",
      priceTrial: "prueba gratuita",
      priceQuote: "Bajo presupuesto",
      customLine: "¿Un evento más grande?",
      customCta: "Pide presupuesto para un paquete a medida",
      tierGuests: "{{range}} invitados",
      priceNote: "Pago único, sin suscripción. Noche de henna y boda en un solo precio; diseño de tarjetas de mesa y cartel de bienvenida incluido.",
      retention: "El álbum permanece en línea al menos {{months}} meses; descárgalo completo cuando quieras.",
    },
    print: {
      eyebrow: "Impresión",
      title: "Listos para las mesas.",
      titleAccent: "Cada superficie, una invitación.",
      lead: "Imprime tu código QR con el estilo de tu boda. De la tarjeta de mesa al cartel de bienvenida, descarga nuestros diseños de ejemplo.",
      tableCard: "Tarjeta de mesa",
      tableCardSize: "A6 · 105 × 148 mm",
      sign: "Cartel de bienvenida",
      signSize: "50 × 70 cm",
      handCard: "Tarjeta de mano",
      handCardSize: "85 × 55 mm",
      download: "PDF de ejemplo",
      sampleNote: "Diseños de ejemplo: el QR abre una página de invitación de ejemplo. Las versiones con tu propio QR llegarán desde el panel del organizador.",
    },
    contact: {
      eyebrow: "Presupuesto",
      title: "Tu precio",
      titleAccent: "en 30 segundos.",
      lead: "Elige el número de invitados y la fecha, dinos cómo contactarte y te enviamos tu presupuesto en breve.",
      point1: "Henna, ceremonia y boda en un solo presupuesto",
      point2: "Diseño de tarjetas de mesa y carteles incluido",
      point3: "Sin presión comercial: solo una respuesta",
      directLabel: "¿Prefieres el correo?",
      directCta: "Escríbenos",
      step1: "Tu evento",
      step2: "¿Cómo te contactamos?",
      stepCount: "Paso {{n}} de 2",
      next: "Continuar",
      back: "Atrás",
      addNote: "Añadir una nota",
      name: "Nombre y apellidos",
      namePh: "Ayşe Yılmaz",
      email: "Correo electrónico",
      emailPh: "tu@ejemplo.com",
      phone: "Teléfono",
      eventType: "Evento",
      eventDate: "Fecha del evento",
      package: "Paquete",
      packageHint: "Elige el paquete que se ajusta a tu número de invitados.",
      packageGuests: "hasta {{n}} invitados",
      packageCustom: "Más grande · presupuesto a medida",
      estimate: "Precio estimado",
      message: "Tu mensaje",
      messagePh: "Lugar, hora, cualquier cosa que tengas en mente…",
      optional: "opcional",
      evWedding: "Boda",
      evWeddingHenna: "Boda + Henna",
      evHenna: "Noche de henna",
      evEngagement: "Compromiso",
      evPromise: "Pedida",
      evOther: "Otro",
      rangeUpTo: "Hasta {{n}}",
      rangeBetween: "{{min}}–{{max}}",
      rangeOver: "{{n}}+",
      consent: "Doy mi consentimiento expreso para que mis datos personales se transfieran a los proveedores en el extranjero indicados en el aviso de privacidad (correo electrónico y alojamiento) a fin de enviar mi solicitud de presupuesto.",
      submit: "Recibir mi presupuesto",
      sending: "Enviando…",
      successTitle: "Tu solicitud nos ha llegado.",
      successBody: "Te responderemos en breve en {{email}} o por teléfono.",
      successAgain: "Enviar otra solicitud",
      errName: "Escribe tu nombre y apellidos.",
      errEmail: "Escribe un correo electrónico válido.",
      errPhone: "Escribe un número de teléfono válido.",
      errChoice: "Elige una opción.",
      errDate: "Elige una fecha a partir de hoy.",
      errConsent: "Debes dar tu consentimiento para continuar.",
      errVerify: "La verificación de seguridad no ha terminado; inténtalo de nuevo en unos segundos.",
      toastSent: "Tu solicitud se ha enviado.",
      toastFailed: "No se pudo enviar: puedes mandar tu solicitud por correo.",
      toastInvalid: "Corrige los campos marcados.",
      fallbackTitle: "El formulario no se pudo enviar ahora.",
      fallbackBody: "Tus datos están en un correo listo para enviar; mándalo con un toque.",
      fallbackCta: "Enviar por correo",
      mailSubject: "Solicitud de presupuesto — {{name}} · {{event}} · {{date}}",
      mailGreeting: "Hola,",
      mailIntro: "Me gustaría un presupuesto de {{brand}}.",
      mailMessage: "Mensaje",
      mailPlan: "Paquete",
      mailClosing: "Gracias.",
    },
    faq: {
      eyebrow: "Preguntas",
      title: "Preguntas frecuentes",
      q1: "¿Los invitados tienen que descargar una app?",
      a1: "No. Basta con escanear el código QR con la cámara del móvil; todo se abre en el navegador. Quien quiera puede añadirlo a su pantalla de inicio y usarlo como una app.",
      q2: "¿Se comprimen las fotos?",
      a2: "No. Los archivos se suben tal y como están en el móvil del invitado: hasta {{photo}} por foto y {{video}} por vídeo.",
      q3: "¿Quién puede ver el álbum?",
      a3: "Solo los invitados que entran verificando su número de teléfono, y solo ven las fotos que tú has aprobado.",
      q4: "¿Puede aparecer en pantalla una foto inapropiada?",
      a4: "No. Cada foto pasa primero por la cola de moderación; Sahne solo proyecta lo que has aprobado. Si hace falta, bloqueas a quien la envió con un toque.",
      q5: "¿Necesito un álbum aparte para la henna y la boda?",
      a5: "No. Añades los dos eventos a la misma boda; cuando pasa el primero, la cuenta atrás y el lugar cambian solos al segundo.",
      q6: "¿Qué necesito para Sahne?",
      a6: "Una pantalla o un proyector conectado a internet y un navegador. Abre Sahne a pantalla completa y dirige el ritmo desde Reji con tu móvil.",
      q7: "Algunos invitados son extranjeros, ¿es un problema?",
      a7: "En absoluto. La interfaz está en turco, inglés, francés y español; cada invitado elige su idioma.",
      q8: "¿Cuánto tiempo permanece el álbum en línea?",
      a8: "Tu álbum permanece en línea al menos {{months}} meses. Durante ese tiempo puedes descargar desde tu panel, con un clic, todas las fotos y vídeos aprobados en calidad original como ZIP.",
    },
    finale: {
      title1: "Antes de que acabe la noche,",
      title2: "las mejores fotos",
      title3: "ya están en pantalla.",
      lead: "Pide tu presupuesto: tu código QR estará listo para las mesas.",
      cta: "Pedir presupuesto",
      secondary: "Abrir una invitación de ejemplo",
    },
    footer: {
      tagline: "Lo que te perdiste, en un solo álbum.",
      product: "Producto",
      account: "Cuenta",
      organizerLogin: "Acceso para organizadores",
      quote: "Pedir presupuesto",
      demo: "Invitación de ejemplo",
      rights: "Todos los derechos reservados.",
    },
  },
  weddingTelegram: {
    title: "Notificaciones de Telegram",
    subtitle: "Los eventos de esta boda llegan a los chats de Telegram que elijas: tu propio chat o el grupo de la pareja / del equipo.",
    unavailable: "Las notificaciones de Telegram no se pueden configurar ahora (actualización del sistema pendiente).",
    botMissing: "El bot de Telegram no está configurado — avisa al administrador.",
    loadFailed: "No se pudieron cargar las conexiones de Telegram.",
    retry: "Reintentar",
    connectPrivate: "Conectar mi Telegram",
    connectPrivateHint: "Las notificaciones te llegan solo a ti.",
    connectGroup: "Añadir a un grupo",
    connectGroupHint: "El grupo de la pareja o del equipo — eliges el grupo en Telegram.",
    waitingPrivate: "Abre Telegram y toca “Iniciar”. Aparece aquí al conectarse.",
    waitingGroup: "Elige el grupo en Telegram y añade el bot. Aparece aquí al conectarse.",
    openTelegram: "Abrir en Telegram",
    expiresIn: "Enlace válido durante {{time}}",
    expired: "El enlace ha caducado. Crea uno nuevo.",
    cancel: "Cancelar",
    linked: "Telegram conectado: {{name}}",
    linkFailed: "No se pudo crear el enlace",
    chatsTitle: "Chats conectados",
    empty: "Aún no hay chats conectados.",
    private: "Personal",
    group: "Grupo",
    unnamedPrivate: "Chat personal",
    unnamedGroup: "Grupo",
    eventsLabel: "Tipos de notificación para {{name}}",
    remove: "Quitar",
    removeConfirm: "“{{name}}” dejará de recibir las notificaciones de esta boda. ¿Quitarlo?",
    removed: "Chat quitado",
    saved: "Selección de notificaciones guardada",
    saveFailed: "No se pudo guardar",
    stale: "La selección cambió en otro lugar — se cargó la versión actual.",
    footer: "Si bloqueas el bot o lo quitas del grupo, la conexión desaparece sola. /status en el chat muestra las bodas conectadas.",
    events: {
      media_upload: "Nuevo contenido (pendiente)",
      guest_join: "Nuevo invitado",
      rsvp_submitted: "Respuesta RSVP",
      comment_created: "Comentario",
      capacity: "Alertas de cupo",
    },
    errors: {
      migration_required: "Las notificaciones de Telegram no se pueden configurar ahora (actualización del sistema pendiente).",
      bot_unavailable: "No se pudo contactar con el bot de Telegram, inténtalo en un momento.",
      generic: "Error: {{error}}",
    },
  },

} as const;

export default es;
